var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FCE7BA"
    },
    width: 750,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 750,
    height: 500
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114782991440925318670000000285624642475273142_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114782991440925318670000000285624642475273142_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DE6DF"
    },
    d: "M116.995,499.831c0,0,19.779-99.426-14.489-139.126 c-34.268-39.699-82.356,57.767-123.884,2.627c-41.528-55.141-104.079-164.926-176.762-106.347 c-72.683,58.579,57.978,200.691,24.847,297.907s-33.837,164.814,27.668,201.112 C-101.673,781.943,66.543,683.766,116.995,499.831z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACE3DF"
    },
    d: "M-256.347,591.113c-4.92-35.02,47.852-45.657,54.558-10.984 c0.095,0.493,0.181,0.995,0.256,1.505c4.206,28.603-16.203,54.299-32.574,47.412 C-243.257,625.198-253.863,608.794-256.347,591.113z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACE3DF"
    },
    d: "M97.098,601.398c16.565-22.625,45.714,9.227,30.129,32.938 c-0.222,0.337-0.452,0.672-0.693,1.005c-13.446,18.613-36.276,18.074-39.864,2.633 C84.665,629.342,88.734,612.82,97.098,601.398z"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114782991440925318670000000285624642475273142_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M127.422,406.84c-11.327,0-24.76-1.956-33.288-4.409c-1.332-0.383-2.591-0.753-3.794-1.106 c-16.192-4.753-22.251-6.532-62.828,1.211c-0.969,0.185-1.941,0.379-2.931,0.577c-6.75,1.347-14.399,2.874-27.815,2.874 c-15.388,0-23.204-1.756-30.762-3.454c-7.361-1.653-14.974-3.362-29.946-3.362c-14.971,0-22.583,1.709-29.944,3.362 c-7.558,1.698-15.373,3.454-30.76,3.454c-15.387,0-23.202-1.756-30.76-3.454c-7.361-1.653-14.974-3.362-29.943-3.362v-1 c15.081,0,22.748,1.722,30.162,3.387c7.505,1.686,15.265,3.429,30.541,3.429c15.276,0,23.036-1.743,30.542-3.429 c7.414-1.665,15.081-3.387,30.163-3.387c15.083,0,22.75,1.722,30.164,3.387c7.506,1.686,15.267,3.429,30.543,3.429 c13.317,0,20.915-1.517,27.619-2.854c0.993-0.198,1.967-0.393,2.939-0.578c40.815-7.788,46.937-5.991,63.298-1.189 c1.201,0.353,2.458,0.722,3.789,1.104c11.101,3.193,30.578,5.54,42.685,3.758c8.64-1.27,19.306-3.161,31.701-5.622 c28.02-5.562,44.6-1.375,57.924,1.99c7.201,1.819,13.42,3.39,19.549,2.657l0.119,0.993c-6.312,0.75-12.615-0.838-19.913-2.681 c-13.227-3.34-29.688-7.496-57.483-1.978c-12.412,2.464-23.095,4.358-31.752,5.63 C134.319,406.648,130.974,406.84,127.422,406.84z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M127.422,420.511c-11.327,0-24.76-1.956-33.288-4.409c-1.332-0.383-2.591-0.753-3.794-1.106 c-16.193-4.753-22.252-6.532-62.828,1.212c-0.971,0.185-1.944,0.379-2.936,0.577c-6.748,1.347-14.397,2.873-27.81,2.873 c-15.383,0-23.202-1.756-30.762-3.454c-7.361-1.653-14.974-3.362-29.946-3.362c-14.971,0-22.583,1.709-29.944,3.362 c-7.56,1.698-15.378,3.454-30.76,3.454c-15.383,0-23.2-1.756-30.76-3.454c-7.361-1.653-14.974-3.362-29.943-3.362v-1 c15.081,0,22.748,1.722,30.162,3.387c7.507,1.686,15.269,3.429,30.541,3.429c15.271,0,23.034-1.743,30.541-3.429 c7.415-1.665,15.082-3.387,30.164-3.387c15.083,0,22.75,1.722,30.164,3.387c7.508,1.686,15.271,3.429,30.543,3.429 c13.313,0,20.911-1.516,27.614-2.853c0.995-0.198,1.971-0.393,2.944-0.579c40.815-7.788,46.937-5.992,63.297-1.189 c1.202,0.352,2.459,0.722,3.79,1.104c11.101,3.194,30.578,5.54,42.685,3.759c8.645-1.271,19.311-3.163,31.701-5.622 c28.02-5.56,44.601-1.374,57.923,1.99c7.201,1.819,13.421,3.39,19.55,2.657l0.119,0.993 c-6.313,0.756-12.616-0.838-19.914-2.681c-13.226-3.34-29.684-7.496-57.482-1.979c-12.408,2.463-23.091,4.357-31.752,5.631 C134.319,420.319,130.974,420.511,127.422,420.511z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M127.424,434.181c-11.328,0-24.762-1.956-33.29-4.409c-1.333-0.383-2.592-0.753-3.795-1.106 c-16.192-4.753-22.252-6.531-62.827,1.212c-0.971,0.185-1.944,0.379-2.936,0.577c-6.748,1.347-14.397,2.873-27.81,2.873 c-15.383,0-23.202-1.756-30.762-3.454c-7.363-1.653-14.976-3.363-29.946-3.363c-14.969,0-22.581,1.709-29.943,3.363 c-7.562,1.698-15.379,3.454-30.762,3.454c-15.383,0-23.2-1.756-30.76-3.454c-7.364-1.653-14.976-3.363-29.943-3.363v-1 c15.079,0,22.745,1.722,30.16,3.387c7.509,1.686,15.271,3.43,30.544,3.43c15.271,0,23.034-1.743,30.541-3.429 c7.416-1.665,15.084-3.387,30.164-3.387c15.081,0,22.749,1.722,30.164,3.387c7.508,1.686,15.271,3.429,30.543,3.429 c13.313,0,20.911-1.516,27.614-2.853c0.995-0.198,1.971-0.393,2.944-0.579c40.814-7.789,46.935-5.991,63.296-1.189 c1.202,0.353,2.459,0.722,3.791,1.104c11.101,3.193,30.575,5.536,42.685,3.759c8.645-1.271,19.311-3.163,31.701-5.622 c28.02-5.561,44.602-1.373,57.923,1.99c7.201,1.818,13.421,3.391,19.55,2.657l0.119,0.993 c-6.312,0.754-12.615-0.838-19.914-2.681c-13.225-3.339-29.689-7.494-57.482-1.979c-12.408,2.463-23.091,4.357-31.752,5.631 C134.32,433.989,130.975,434.181,127.424,434.181z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M127.422,447.852c-11.327,0-24.76-1.956-33.288-4.409c-1.332-0.383-2.591-0.753-3.794-1.106 c-16.192-4.753-22.251-6.532-62.828,1.211c-0.969,0.185-1.941,0.379-2.931,0.577c-6.75,1.347-14.399,2.874-27.815,2.874 c-15.388,0-23.204-1.756-30.762-3.454c-7.361-1.653-14.974-3.362-29.946-3.362c-14.971,0-22.583,1.709-29.944,3.362 c-7.558,1.698-15.373,3.454-30.76,3.454c-15.387,0-23.202-1.756-30.76-3.454c-7.361-1.653-14.974-3.362-29.943-3.362v-1 c15.081,0,22.748,1.722,30.162,3.387c7.505,1.686,15.265,3.429,30.541,3.429c15.276,0,23.036-1.743,30.542-3.429 c7.414-1.665,15.081-3.387,30.163-3.387c15.083,0,22.75,1.722,30.164,3.387c7.506,1.686,15.267,3.429,30.543,3.429 c13.317,0,20.915-1.517,27.619-2.854c0.993-0.198,1.967-0.393,2.939-0.578c40.815-7.788,46.937-5.991,63.298-1.189 c1.201,0.353,2.458,0.722,3.789,1.104c11.101,3.193,30.578,5.539,42.685,3.758c8.64-1.27,19.306-3.161,31.701-5.622 c28.02-5.562,44.6-1.374,57.924,1.99c7.201,1.818,13.42,3.391,19.549,2.657l0.119,0.993 c-6.312,0.751-12.615-0.838-19.913-2.681c-13.227-3.34-29.688-7.497-57.483-1.978c-12.412,2.464-23.095,4.358-31.752,5.63 C134.319,447.66,130.974,447.852,127.422,447.852z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M127.423,461.523c-11.329,0-24.761-1.956-33.289-4.409c-1.332-0.383-2.591-0.753-3.794-1.106 c-16.193-4.752-22.252-6.532-62.828,1.212c-0.971,0.185-1.944,0.379-2.936,0.577c-6.748,1.347-14.397,2.873-27.81,2.873 c-15.383,0-23.202-1.756-30.762-3.454c-7.363-1.653-14.976-3.363-29.946-3.363c-14.969,0-22.581,1.71-29.943,3.363 c-7.562,1.698-15.379,3.454-30.762,3.454c-15.383,0-23.2-1.756-30.76-3.454c-7.364-1.653-14.976-3.363-29.943-3.363v-1 c15.079,0,22.745,1.722,30.16,3.387c7.509,1.686,15.271,3.43,30.544,3.43c15.271,0,23.034-1.743,30.541-3.429 c7.416-1.665,15.084-3.387,30.164-3.387c15.081,0,22.749,1.722,30.164,3.387c7.508,1.686,15.271,3.429,30.543,3.429 c13.313,0,20.911-1.516,27.614-2.853c0.995-0.198,1.971-0.393,2.944-0.579c40.815-7.788,46.937-5.992,63.297-1.189 c1.202,0.352,2.459,0.722,3.79,1.104c11.1,3.193,30.574,5.54,42.685,3.759c8.645-1.271,19.311-3.163,31.701-5.622 c28.02-5.561,44.601-1.374,57.923,1.99c7.201,1.818,13.421,3.39,19.55,2.657l0.119,0.993 c-6.313,0.754-12.616-0.838-19.914-2.681c-13.226-3.339-29.684-7.495-57.482-1.979c-12.408,2.463-23.091,4.357-31.752,5.631 C134.319,461.33,130.974,461.523,127.423,461.523z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114782991440925318670000000285624642475273142_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DE6DF"
    },
    d: "M305.123,85.942c39.906,3.128,48.26-57.23,8.622-62.4c-0.564-0.074-1.137-0.135-1.719-0.184 c-32.606-2.765-60.22,22.075-51.303,40.092C265.707,73.52,284.975,84.363,305.123,85.942z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DE6DF"
    },
    d: "M605.69-10.003c0,0-36.249,114.573-142.829,80.092c-106.58-34.481-154.803-97.613-222.032-24.318 c-67.23,73.295-205.178-223.962-205.178-223.962l199.821-200.3L605.268-9.58"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114782991440925318670000000285624642475273142_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DE6DF"
    },
    d: "M684.037,689.995c0,0,114.028-24.202,140.431-78.417c26.403-54.216-98.395-60.816-58.97-129.707 c39.426-68.891,127.054-184.783,32.189-235.009c-94.865-50.227-185.756,152.295-303.504,161.384 c-117.748,9.09-189.494,39.007-199.949,120.459C286.763,586.912,466.802,720.121,684.037,689.995z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DE6DF"
    },
    d: "M541.839,374.376c-36.284,18.359-67.456-35.121-32.213-55.295 c0.501-0.287,1.016-0.566,1.543-0.837c29.566-15.198,65.109-2.531,63.693,17.842 C574.071,347.474,560.158,365.107,541.839,374.376z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DE6DF"
    },
    d: "M567.694,715.042c31.42,7.24,10.986,52.488-21.136,46.776c-0.457-0.081-0.915-0.173-1.375-0.276 c-25.766-5.765-35.553-30.131-20.865-40.926C532.528,714.581,551.831,711.387,567.694,715.042z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114782991440925318670000000285624642475273142_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M587.75,647.302c-2.803,0.726-5.664-0.958-6.39-3.761l-66.283-255.904 c-0.726-2.803,0.958-5.664,3.761-6.39c2.803-0.726,5.664,0.958,6.39,3.761l66.283,255.904 C592.236,643.714,590.553,646.576,587.75,647.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CBE91"
    },
    d: "M532.338,420.879l-5.577,1.444c-3.156,0.817-6.377-1.078-7.194-4.234l-5.24-20.231l17.005-4.405 l5.24,20.231C537.389,416.84,535.493,420.061,532.338,420.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M532.338,420.879l-5.577,1.444c-3.156,0.817-6.377-1.078-7.194-4.234l-5.24-20.231l17.005-4.405 l5.24,20.231C537.389,416.84,535.493,420.061,532.338,420.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CBE91"
    },
    d: "M528.806,410.726l-3.665,0.949c-14.523,3.762-29.347-4.962-33.109-19.486l-12.112-46.762 c-3.762-14.524,4.962-29.347,19.486-33.109l3.665-0.949c14.524-3.762,29.347,4.962,33.109,19.486l12.112,46.762 C552.054,392.141,543.33,406.964,528.806,410.726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M528.806,410.726l-3.665,0.949c-14.523,3.762-29.347-4.962-33.109-19.486l-12.112-46.762 c-3.762-14.524,4.962-29.347,19.486-33.109l3.665-0.949c14.524-3.762,29.347,4.962,33.109,19.486l12.112,46.762 C552.054,392.141,543.33,406.964,528.806,410.726z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M492.855,314.96l2.185,8.435c0.517,1.996-0.683,4.035-2.679,4.552 c-1.992,0.516-4.03-0.684-4.547-2.68l-1.368-5.283C488.293,318.019,490.446,316.316,492.855,314.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M504.866,310.972l2.398,9.257c0.517,1.996-0.678,4.034-2.674,4.551 c-1.996,0.517-4.03-0.684-4.547-2.68l-2.398-9.257c0.578-0.196,1.163-0.368,1.762-0.524l3.664-0.949 C503.671,311.215,504.265,311.082,504.866,310.972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M518.125,311.778l1.369,5.283c0.517,1.996-0.683,4.035-2.679,4.552 c-1.992,0.516-4.03-0.684-4.547-2.68l-2.185-8.435C512.846,310.515,515.555,310.958,518.125,311.778z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M498.805,337.935c0.258,0.996,0.087,2.01-0.396,2.831c-0.484,0.822-1.287,1.463-2.283,1.721 l-15.903,4.119l-0.305-1.179c-0.54-2.083-0.823-4.171-0.865-6.229l15.202-3.938 C496.251,334.744,498.288,335.939,498.805,337.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M502.571,352.475c0.258,0.996,0.087,2.01-0.396,2.831c-0.483,0.822-1.287,1.463-2.283,1.721 l-15.903,4.119l-1.872-7.227l15.903-4.119C500.017,349.284,502.056,350.484,502.571,352.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M506.338,367.015c0.258,0.996,0.087,2.01-0.396,2.831c-0.483,0.822-1.287,1.463-2.283,1.721 l-15.903,4.119l-1.872-7.227l15.903-4.119C503.783,363.824,505.822,365.023,506.338,367.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M510.104,381.555c0.258,0.996,0.087,2.01-0.396,2.831c-0.483,0.822-1.287,1.463-2.283,1.721 l-15.903,4.119L489.65,383l15.903-4.119C507.549,378.363,509.588,379.563,510.104,381.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M513.87,396.095c0.258,0.996,0.087,2.01-0.396,2.831c-0.484,0.822-1.287,1.463-2.283,1.721 l-12.703,3.29c-1.795-1.913-3.329-4.11-4.525-6.539l15.357-3.978C511.315,392.904,513.354,394.103,513.87,396.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M536.178,330.855l0.305,1.179l-16.121,4.175c-1.996,0.517-4.035-0.683-4.552-2.679 c-0.517-1.996,0.684-4.03,2.68-4.547l15.42-3.994C534.872,326.809,535.638,328.772,536.178,330.855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M538.378,339.348l1.872,7.227l-16.121,4.175c-1.996,0.517-4.035-0.683-4.552-2.679 c-0.516-1.991,0.684-4.03,2.68-4.547L538.378,339.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M542.144,353.888l1.872,7.227l-16.12,4.175c-1.996,0.517-4.035-0.683-4.552-2.679 c-0.516-1.992,0.684-4.03,2.68-4.547L542.144,353.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M545.91,368.427l1.872,7.227l-16.121,4.176c-1.996,0.517-4.035-0.683-4.552-2.679 c-0.516-1.992,0.684-4.03,2.68-4.547L545.91,368.427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M549.13,383.109c0.133,2.704-0.141,5.37-0.782,7.914l-12.921,3.347 c-1.996,0.517-4.035-0.683-4.552-2.679c-0.516-1.992,0.684-4.03,2.68-4.547L549.13,383.109z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114782991440925318670000000285624642475273142_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M145.882,120.89c-0.893,1.998-1.561,3.928-2.002,5.729l-47.54-11.572 c1.224-5.009,2.904-9.713,4.868-14.112L145.882,120.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M150.277,113.115c-1.412,2.076-2.634,4.155-3.643,6.184L102.82,97.523 c2.112-4.246,4.474-8.208,7.003-11.928L150.277,113.115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M156.444,105.334c-1.82,2.015-3.503,4.072-5.014,6.144l-39.576-28.769 c2.617-3.593,5.384-6.961,8.26-10.148L156.444,105.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M163.936,97.928c-2.119,1.886-4.137,3.832-6.028,5.824l-35.501-33.669 c2.933-3.091,5.968-6.009,9.086-8.781L163.936,97.928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M172.444,91.124c-2.349,1.708-4.624,3.488-6.807,5.332l-31.66-37.304 c3.169-2.681,6.417-5.221,9.737-7.633L172.444,91.124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M181.686,85.044c-2.514,1.502-4.989,3.074-7.372,4.748L146.35,49.643 c3.354-2.351,6.796-4.545,10.298-6.635L181.686,85.044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M191.458,79.795c-2.635,1.256-5.23,2.626-7.773,4.082l-24.257-42.492 c3.539-2.025,7.147-3.927,10.837-5.691L191.458,79.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M146.247,120.115c-0.95,2.014-1.676,3.968-2.17,5.799l-47.231-12.775 c1.336-4.934,3.104-9.558,5.141-13.881L146.247,120.115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M150.842,112.316c-1.458,2.074-2.737,4.156-3.801,6.197l-43.39-22.61 c2.176-4.173,4.591-8.063,7.162-11.722L150.842,112.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M157.146,104.555c-1.849,2.007-3.566,4.058-5.116,6.126l-39.154-29.34 c2.653-3.54,5.449-6.862,8.35-10.007L157.146,104.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M164.769,97.209c-2.15,1.866-4.203,3.794-6.133,5.772L123.54,68.89 c2.962-3.041,6.024-5.912,9.167-8.639L164.769,97.209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M173.355,90.469c-2.377,1.679-4.67,3.448-6.868,5.281l-31.281-37.622 c3.185-2.653,6.449-5.164,9.794-7.532L173.355,90.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M182.658,84.464c-2.532,1.478-5.005,3.05-7.415,4.692l-27.591-40.407 c3.381-2.304,6.827-4.491,10.348-6.546L182.658,84.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M192.474,79.31c-2.639,1.244-5.245,2.584-7.806,4.009L160.797,40.61 c3.561-1.985,7.191-3.851,10.892-5.594L192.474,79.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M130.536,108.303c-0.449,0.784-0.831,1.595-1.252,2.389c-0.402,0.802-0.761,1.619-1.146,2.427 l-27.018-11.994c0.557-1.196,1.105-2.413,1.69-3.584c0.598-1.152,1.177-2.338,1.808-3.453L130.536,108.303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M137.396,97.917l-1.648,2.197l-1.571,2.241l-24.475-16.577c0.699-1.026,1.417-2.026,2.13-3.037 l2.2-2.932L137.396,97.917z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "145.761,88.466 144.779,89.45 143.826,90.457 142.872,91.463 141.946,92.492  119.963,72.729 121.155,71.408 122.369,70.124 123.585,68.843 124.822,67.6  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M165.498,72.36c-1.549,1.046-3.087,2.108-4.595,3.209l-17.394-23.901 c1.832-1.337,3.693-2.624,5.567-3.887L165.498,72.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M176.454,65.732c-1.64,0.899-3.269,1.819-4.87,2.786l-15.167-25.373 c1.93-1.163,3.891-2.274,5.867-3.356L176.454,65.732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M130.536,108.303c-0.34,0.578-0.62,1.18-0.932,1.768l-0.458,0.887l-0.42,0.901l-26.74-12.601 l0.626-1.33l0.659-1.289c0.446-0.851,0.874-1.733,1.346-2.551L130.536,108.303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M137.405,97.906c-0.812,1.086-1.645,2.159-2.407,3.274l-24.185-16.998 c1.044-1.514,2.14-2.944,3.231-4.389L137.405,97.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M145.782,88.445c-0.981,0.961-1.91,1.967-2.854,2.96l-21.701-20.072 c1.198-1.267,2.392-2.548,3.623-3.76L145.782,88.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M165.548,72.327c-1.144,0.779-2.295,1.549-3.417,2.359l-17.132-24.09 c1.363-0.981,2.752-1.914,4.137-2.855L165.548,72.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M176.52,65.697c-1.223,0.651-2.417,1.356-3.622,2.038L158,42.203 c1.45-0.826,2.891-1.669,4.363-2.456L176.52,65.697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M196.911,77.593c-0.517,0.111-1.028,0.236-1.574,0.453c-0.136,0.043-0.275,0.091-0.416,0.161 l-0.462,0.189l-1.985,0.913l-20.785-44.294l2.79-1.282l1.961-0.83c0.661-0.282,1.343-0.541,2.034-0.788 c2.732-1.022,5.61-1.831,8.521-2.436L196.911,77.593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M201.632,77.55c-0.792-0.107-1.516-0.181-2.152-0.187c-0.636-0.003-1.207,0.028-1.745,0.084 l-6.11-48.545c2.942-0.359,5.876-0.503,8.744-0.459c2.869,0.048,5.64,0.309,8.316,0.69L201.632,77.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M209.154,79.674c-1.164-0.45-2.261-0.82-3.306-1.148c-1.037-0.316-1.997-0.552-2.889-0.744 l9.848-47.927c2.537,0.53,4.975,1.159,7.291,1.864c2.302,0.71,4.521,1.477,6.626,2.29L209.154,79.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M218.847,84.122c-2.75-1.405-5.383-2.674-7.813-3.689l18.939-45.114 c4.036,1.692,7.713,3.485,11.203,5.267L218.847,84.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M229.948,90.094c-3.095-1.697-6.063-3.331-8.891-4.82l22.816-43.282 c3.373,1.778,6.543,3.526,9.593,5.198L229.948,90.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M242.429,96.73c-3.514-1.767-6.827-3.55-10.005-5.281l23.419-42.959 c2.976,1.622,5.837,3.156,8.585,4.537L242.429,96.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M256.75,103.154c-4.091-1.568-7.891-3.288-11.514-5.035l21.345-44.026 c2.688,1.296,5.283,2.46,7.738,3.397L256.75,103.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M197.311,77.514c-0.52,0.102-1.028,0.204-1.558,0.383c-0.133,0.03-0.267,0.103-0.404,0.145 c-0.136,0.045-0.274,0.089-0.416,0.16c-0.148,0.066-0.267,0.11-0.445,0.181l-0.992,0.458l-20.372-44.485l1.396-0.64l1.978-0.835 c0.661-0.282,1.346-0.538,2.036-0.785c0.691-0.245,1.369-0.506,2.076-0.723c2.8-0.919,5.712-1.614,8.642-2.117L197.311,77.514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M202.261,77.646c-0.834-0.138-1.591-0.223-2.274-0.267c-0.676-0.034-1.272-0.011-1.83,0.029 l-4.264-48.742c2.933-0.248,5.848-0.295,8.671-0.147c2.816,0.157,5.543,0.486,8.163,0.938L202.261,77.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M210.063,80.034c-2.381-0.963-4.552-1.668-6.402-2.095l11.085-47.656 c4.977,1.159,9.467,2.704,13.583,4.36L210.063,80.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M219.922,84.679c-2.796-1.458-5.455-2.758-7.941-3.843l19.535-44.859 c3.937,1.719,7.569,3.517,10.988,5.297L219.922,84.679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M231.152,90.754c-3.14-1.719-6.128-3.368-8.998-4.899l23.011-43.179 c3.313,1.768,6.461,3.507,9.468,5.153L231.152,90.754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M243.791,97.41c-3.561-1.761-6.916-3.548-10.136-5.292l23.333-43.006 c2.942,1.594,5.776,3.098,8.498,4.442L243.791,97.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M258.334,103.755c-4.134-1.537-8.036-3.221-11.69-4.963l20.969-44.207 c2.671,1.276,5.217,2.354,7.651,3.264L258.334,103.755z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M197.787,58.029c-1.667,0.067-3.313,0.273-4.93,0.625l-6.118-28.92 c3.217-0.691,6.501-1.099,9.721-1.235L197.787,58.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M209.389,59.408c-1.706-0.443-3.414-0.815-5.114-1.046l4.154-29.267 c2.971,0.412,5.77,1.02,8.446,1.716L209.389,59.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M221.028,63.662c-1.689-0.762-3.383-1.472-5.081-2.125l10.553-27.613 c2.332,0.895,4.561,1.834,6.693,2.795L221.028,63.662z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "244.203,75.804 239.068,73.008 253.278,47.087 258.22,49.778  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M256.312,81.934c-1.82-0.842-3.617-1.713-5.385-2.61l13.322-26.389 c1.527,0.775,3.013,1.493,4.469,2.167L256.312,81.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M197.787,58.029l-0.924,0.05c-0.307,0.02-0.612,0.061-0.918,0.089 c-0.614,0.047-1.217,0.156-1.824,0.243l-4.868-29.157c1.202-0.187,2.407-0.377,3.609-0.486c0.601-0.059,1.205-0.127,1.804-0.169 l1.795-0.102L197.787,58.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M209.403,59.411c-1.264-0.345-2.528-0.601-3.79-0.84l5.115-29.115 c2.118,0.388,4.205,0.831,6.168,1.359L209.403,59.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M221.055,63.674c-1.252-0.558-2.504-1.106-3.761-1.607l11.035-27.423 c1.696,0.677,3.308,1.381,4.897,2.091L221.055,63.674z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "244.258,75.834 240.447,73.763 254.634,47.829 258.271,49.806  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M256.384,81.967c-1.351-0.62-2.683-1.264-4.005-1.916l13.107-26.496 c1.113,0.549,2.213,1.081,3.288,1.574L256.384,81.967z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M271.633,107.684c-4.731-1.025-9.134-2.41-13.299-3.929l16.93-45.905 c2.418,0.877,4.719,1.59,6.842,2.041L271.633,107.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M290.621,109.584c-1.31,0.052-2.6,0.009-3.899-0.002c-1.282-0.061-2.581-0.095-3.844-0.214 c-2.553-0.184-5.03-0.533-7.47-0.938l8.348-48.21c1.017,0.16,2.013,0.314,2.956,0.372c0.482,0.057,0.936,0.045,1.404,0.083 c0.452-0.013,0.915,0.028,1.356-0.004L290.621,109.584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M310.554,106.278c-1.324,0.401-2.662,0.823-3.988,1.162c-1.318,0.3-2.641,0.586-3.966,0.859 c-1.336,0.299-2.618,0.458-3.926,0.658c-1.305,0.16-2.615,0.319-3.923,0.415L290.866,60.6c0.439-0.027,0.868-0.092,1.303-0.135 c0.422-0.081,0.886-0.109,1.254-0.224c0.389-0.094,0.779-0.174,1.174-0.241c0.369-0.098,0.696-0.233,1.052-0.323 L310.554,106.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M329.393,96.628l-1.679,1.207c-0.562,0.399-1.117,0.802-1.725,1.163 c-1.193,0.742-2.396,1.469-3.606,2.181c-2.497,1.316-5.028,2.624-7.667,3.606L296.69,59.301 c0.665-0.201,1.222-0.575,1.846-0.843c0.288-0.197,0.582-0.379,0.887-0.546c0.156-0.069,0.3-0.196,0.449-0.309 c0.149-0.113,0.299-0.223,0.452-0.33L329.393,96.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M343.339,83.116l-1.137,1.385c-0.376,0.46-0.757,0.92-1.187,1.383l-2.523,2.753 c-0.884,0.911-1.838,1.813-2.765,2.708c-0.903,0.901-1.951,1.768-2.973,2.632l-31.451-37.48c0.314-0.27,0.64-0.493,0.962-0.848 c0.324-0.331,0.658-0.619,0.996-0.963c0.335-0.381,0.677-0.756,1.024-1.126c0.174-0.171,0.348-0.39,0.523-0.611l0.528-0.649 L343.339,83.116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M352.843,69.342c-2.141,3.543-4.43,7.16-7.233,10.86L306.464,50.85 c1.444-1.878,2.916-4.188,4.398-6.64L352.843,69.342z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "359.982,56.382 358.692,58.868 357.334,61.406 356.654,62.675 355.931,63.97  354.481,66.561 312.034,42.225 313.15,40.228 313.709,39.23 314.269,38.181 315.392,36.085 316.522,33.906  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M273.463,108.069c-4.779-0.95-9.3-2.245-13.509-3.734l16.236-46.155 c2.395,0.852,4.638,1.464,6.731,1.885L273.463,108.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M292.638,109.516c-5.229,0.247-10.428-0.031-15.338-0.786l7.237-48.39 c2.016,0.318,3.852,0.378,5.622,0.311L292.638,109.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M312.596,105.612c-1.318,0.47-2.646,0.847-3.976,1.252c-0.664,0.19-1.335,0.406-1.995,0.564 l-1.98,0.44l-1.985,0.42c-0.662,0.135-1.329,0.28-1.974,0.368c-1.3,0.206-2.603,0.397-3.913,0.525l-5.234-48.647 c0.435-0.035,0.865-0.108,1.296-0.172c0.225-0.02,0.41-0.08,0.606-0.126l0.585-0.13l0.59-0.11 c0.193-0.039,0.35-0.117,0.528-0.168c0.34-0.121,0.71-0.191,1.041-0.31L312.596,105.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M331.091,95.36c-4.295,3.359-9.175,6.327-14.356,8.611l-19.548-44.853 c1.221-0.569,2.374-1.244,3.616-2.184L331.091,95.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M344.501,81.685c-2.91,3.7-6.249,7.423-10.17,10.952l-32.536-36.543 c1.278-1.172,2.66-2.655,4.091-4.457L344.501,81.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M353.645,67.983c-2.018,3.495-4.358,7.136-6.982,10.797l-39.64-28.681 c1.449-2.038,2.932-4.282,4.412-6.86L353.645,67.983z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "360.645,55.103 359.357,57.588 358.712,58.831 358.033,60.1 356.674,62.638  355.229,65.228 312.608,41.198 313.725,39.199 314.847,37.103 315.408,36.055 315.974,34.965 317.105,32.783  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M281.823,89.801c-2.096-0.258-4.172-0.609-6.207-1.071l6.396-28.86 c1.185,0.273,2.309,0.454,3.396,0.589L281.823,89.801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M296.368,89.722c-2.119,0.279-4.254,0.482-6.388,0.505l-0.594-29.555 c0.993-0.001,1.947-0.112,2.904-0.229L296.368,89.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M310.533,85.494c-0.494,0.232-0.968,0.511-1.48,0.7l-1.52,0.607l-1.523,0.601 c-0.511,0.188-1.036,0.326-1.554,0.49l-8.881-28.195c0.19-0.061,0.398-0.093,0.577-0.164c0.172-0.08,0.346-0.155,0.521-0.226 c0.176-0.07,0.353-0.135,0.533-0.196c0.187-0.047,0.33-0.175,0.5-0.25L310.533,85.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M331.879,66.155c-0.559,0.849-1.21,1.663-1.812,2.495c-0.31,0.412-0.607,0.831-0.928,1.238 l-0.988,1.21l-22.901-18.692l0.59-0.712c0.198-0.249,0.394-0.536,0.593-0.801l0.599-0.807l0.302-0.402l0.301-0.444 L331.879,66.155z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "339.089,54.407 337.631,57.01 336.104,59.599 310.766,44.376 311.995,42.292  313.228,40.088  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M281.823,89.801c-1.555-0.182-3.091-0.443-4.616-0.735l5.714-29.003 c0.852,0.16,1.686,0.306,2.486,0.395L281.823,89.801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M296.385,89.72c-0.783,0.124-1.574,0.185-2.36,0.279c-0.788,0.078-1.579,0.117-2.369,0.175 l-1.497-29.522c0.358-0.036,0.719-0.044,1.075-0.081c0.353-0.052,0.712-0.063,1.063-0.127L296.385,89.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M310.564,85.479l-1.088,0.538c-0.37,0.163-0.748,0.305-1.123,0.457l-2.255,0.893l-9.916-27.848 c0.255-0.118,0.513-0.225,0.777-0.321c0.13-0.051,0.268-0.088,0.396-0.142l0.362-0.2L310.564,85.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M331.915,66.101c-0.412,0.63-0.881,1.238-1.333,1.852l-1.366,1.838l-23.33-18.154l0.881-1.197 c0.296-0.403,0.596-0.774,0.893-1.237L331.915,66.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M339.128,54.338c-0.722,1.285-1.422,2.575-2.191,3.85l-25.502-14.949 c0.608-1.001,1.216-2.125,1.826-3.21L339.128,54.338z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "365.476,45.523 360.645,55.103 317.105,32.783 321.739,23.591  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M371.301,34.105c-1.531,2.901-3.055,5.916-4.596,8.969l-43.713-21.981 c1.617-3.203,3.254-6.443,4.993-9.741L371.301,34.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M377.186,23.424c-0.803,1.341-1.569,2.761-2.358,4.136l-2.32,4.249L329.354,8.754 c0.906-1.66,1.789-3.315,2.717-4.978c0.951-1.666,1.854-3.329,2.848-4.996L377.186,23.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M383.389,13.474c-0.832,1.286-1.682,2.546-2.506,3.85c-0.809,1.326-1.643,2.611-2.438,3.966 L336.471-3.852c0.981-1.666,2.046-3.327,3.068-4.989c1.048-1.659,2.152-3.308,3.229-4.96L383.389,13.474z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "390.092,4.29 388.711,6.036 387.376,7.84 386.039,9.644 384.748,11.507 344.551,-16.388  346.258,-18.84 348.045,-21.264 349.841,-23.681 351.716,-26.062  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M397.404-4.205c-1.034,1.064-1.999,2.194-2.999,3.289l-2.858,3.372l-37.842-31.015 c1.31-1.551,2.615-3.11,3.939-4.646c1.355-1.499,2.678-3.025,4.08-4.48L397.404-4.205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M405.44-12.084c-2.228,1.976-4.336,4.069-6.425,6.177L363.92-39.998 c2.835-2.877,5.715-5.713,8.724-8.395L405.44-12.084z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "366.077,44.323 361.284,53.848 317.692,31.628 322.35,22.372  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M371.891,32.983c-0.765,1.453-1.532,2.9-2.295,4.402l-1.147,2.235l-1.152,2.281l-43.679-22.047 l1.217-2.41l1.253-2.442c0.825-1.622,1.697-3.272,2.565-4.919L371.891,32.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M377.802,22.381l-1.196,2.03l-1.173,2.08c-0.788,1.371-1.556,2.803-2.328,4.223l-43.056-23.24 c0.901-1.659,1.792-3.314,2.747-4.983l1.411-2.497l1.47-2.5L377.802,22.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M384.051,12.509c-0.87,1.233-1.681,2.548-2.528,3.815c-0.836,1.283-1.635,2.624-2.458,3.931 L337.242-5.137c1.038-1.662,2.04-3.328,3.115-4.982c1.093-1.65,2.134-3.312,3.278-4.948L384.051,12.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M390.8,3.391c-1.853,2.311-3.65,4.693-5.388,7.158L345.428-17.65 c2.3-3.263,4.722-6.48,7.255-9.635L390.8,3.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M398.19-5.038l-1.529,1.618l-1.49,1.654c-1.014,1.092-1.927,2.238-2.889,3.357l-37.567-31.347 c1.316-1.544,2.605-3.125,3.969-4.609c0.677-0.75,1.345-1.507,2.031-2.249l2.08-2.204L398.19-5.038z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M406.291-12.855c-1.096,1.006-2.226,1.979-3.284,3.02l-1.614,1.537l-1.569,1.58l-34.806-34.387 l2.138-2.146l2.189-2.091c1.447-1.409,2.963-2.737,4.454-4.094L406.291-12.855z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "350.697,31.81 348.095,36.979 321.67,23.729 324.33,18.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "356.777,20.199 355.412,22.71 354.077,25.247 327.901,11.512 329.338,8.783  330.832,6.033  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M363.285,8.955c-1.011,1.594-1.954,3.241-2.921,4.869L334.815-1.045 c1.092-1.842,2.152-3.685,3.312-5.521L363.285,8.955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M378.333-11.908l-1.814,2.144c-0.592,0.726-1.164,1.469-1.747,2.203l-23.21-18.306 c0.695-0.875,1.377-1.756,2.085-2.623l2.172-2.573L378.333-11.908z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "387.043,-21.332 385.061,-19.338 383.128,-17.295 361.542,-37.492 363.846,-39.923  366.205,-42.299  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "350.697,31.81 348.768,35.634 322.35,22.372 324.33,18.444  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M356.784,20.185c-0.672,1.242-1.355,2.474-2.008,3.733l-26.123-13.836 c0.698-1.343,1.452-2.708,2.186-4.064L356.784,20.185z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "363.301,8.93 362.197,10.717 361.128,12.53 335.677,-2.507 336.886,-4.553  338.145,-6.595  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "378.372,-11.953 377.028,-10.365 376.357,-9.57 375.712,-8.752 352.683,-27.285  353.454,-28.258 354.256,-29.212 355.865,-31.118  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M387.096-21.385c-0.972,0.992-1.976,1.953-2.916,2.975l-21.385-20.409 c1.124-1.215,2.313-2.364,3.473-3.543L387.096-21.385z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M413.175-18.587c-1.183,0.919-2.328,1.878-3.498,2.81c-1.124,0.979-2.279,1.927-3.386,2.922 L373.8-49.436c1.501-1.345,3.048-2.631,4.574-3.944c1.563-1.261,3.112-2.544,4.695-3.776L413.175-18.587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M422.431-25.249c-2.513,1.683-4.983,3.412-7.374,5.226l-29.474-39.054 c3.194-2.42,6.465-4.715,9.777-6.928L422.431-25.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M432.264-31.268c-1.349,0.732-2.647,1.527-3.955,2.309c-1.321,0.766-2.593,1.592-3.871,2.408 l-26.445-41.165c1.674-1.071,3.347-2.146,5.054-3.144c1.699-1.018,3.394-2.045,5.122-2.991L432.264-31.268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M442.601-36.668c-1.381,0.692-2.796,1.334-4.151,2.06c-1.356,0.723-2.737,1.413-4.077,2.157 l-23.485-42.923c1.725-0.954,3.475-1.84,5.214-2.76c0.868-0.465,1.747-0.895,2.626-1.323l2.638-1.29L442.601-36.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M453.378-41.468l-4.318,1.825c-1.427,0.627-2.831,1.286-4.25,1.924l-20.659-44.353 c1.775-0.804,3.545-1.629,5.327-2.41l5.365-2.268L453.378-41.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M464.54-45.682l-4.455,1.61c-0.747,0.26-1.482,0.541-2.21,0.833l-2.194,0.859l-17.999-45.497 l2.701-1.057c0.899-0.358,1.801-0.701,2.708-1.021l5.433-1.96L464.54-45.682z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "476.03,-49.333 471.452,-47.943 470.307,-47.596 469.178,-47.22 466.919,-46.47  451.397,-92.87 454.127,-93.775 455.492,-94.226 456.861,-94.644 462.342,-96.307  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M414.096-19.289c-2.392,1.812-4.685,3.727-6.942,5.673l-32.188-36.849 c3.045-2.634,6.141-5.206,9.332-7.631L414.096-19.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M423.405-25.894c-1.268,0.828-2.504,1.693-3.76,2.533l-3.669,2.633l-29.162-39.287 c1.621-1.169,3.238-2.348,4.871-3.497c1.651-1.115,3.291-2.253,4.957-3.341L423.405-25.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M433.295-31.846c-1.334,0.75-2.682,1.483-3.976,2.283c-1.305,0.785-2.628,1.549-3.893,2.382 l-26.139-41.36c1.667-1.087,3.374-2.086,5.072-3.105c1.692-1.036,3.418-1.986,5.139-2.951L433.295-31.846z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "443.673,-37.194 439.505,-35.155 435.413,-33.017 412.223,-76.1 417.448,-78.829  422.723,-81.41  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M454.501-41.919c-2.896,1.191-5.787,2.389-8.598,3.704l-20.382-44.481 c3.54-1.648,7.122-3.143,10.709-4.612L454.501-41.919z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "465.703,-46.067 464.573,-45.693 463.46,-45.29 461.232,-44.486 459.005,-43.682  456.811,-42.822 439.073,-88.421 441.774,-89.476 444.489,-90.459 447.206,-91.439 448.565,-91.928 449.929,-92.382  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M477.219-49.67c-1.547,0.422-3.057,0.918-4.589,1.371l-2.29,0.693l-2.259,0.751l-15.28-46.481 l2.73-0.904l2.74-0.833c1.828-0.544,3.651-1.133,5.484-1.636L477.219-49.67z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "405.643,-37.151 404.499,-36.328 403.379,-35.473 401.139,-33.764 382.929,-57.049  385.569,-59.067 386.892,-60.073 388.235,-61.043  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M416.326-44.348c-1.58,1.022-3.19,2.001-4.746,3.058l-16.379-24.608 c1.824-1.235,3.694-2.38,5.542-3.569L416.326-44.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M427.534-50.752c-1.683,0.856-3.319,1.795-4.964,2.716L407.988-73.75 c1.902-1.067,3.799-2.148,5.73-3.135L427.534-50.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M451.134-61.398c-1.761,0.698-3.536,1.365-5.286,2.087l-11.224-27.347 c1.981-0.817,3.976-1.571,5.965-2.356L451.134-61.398z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "463.392,-65.705 457.989,-63.906 448.286,-91.828 454.318,-93.838  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M405.643-37.151c-1.141,0.8-2.235,1.659-3.342,2.501l-18.003-23.446 c1.305-0.994,2.601-2.005,3.938-2.947L405.643-37.151z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "416.339,-44.356 412.811,-42.107 396.642,-66.853 400.757,-69.476  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "427.56,-50.766 425.703,-49.793 423.875,-48.768 409.498,-74.597 411.613,-75.779  413.749,-76.902  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "451.19,-61.42 447.269,-59.885 436.23,-87.308 440.652,-89.038  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "463.463,-65.729 459.459,-64.4 449.929,-92.382 454.398,-93.865  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M486.532-52.141c-1.558,0.4-3.135,0.759-4.678,1.19l-4.635,1.28l-13.464-47.039l5.498-1.519 c1.833-0.508,3.672-0.934,5.509-1.404L486.532-52.141z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "498.49,-54.837 496.1,-54.36 493.732,-53.827 488.998,-52.759 477.663,-100.355  483.183,-101.604 485.944,-102.222 488.707,-102.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "510.631,-57.09 505.809,-56.239 503.398,-55.816 501.007,-55.34 491.616,-103.358  494.38,-103.905 497.145,-104.394 502.676,-105.366  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "522.94,-58.875 518.048,-58.227 513.189,-57.482 505.587,-105.815 511.118,-106.661  516.648,-107.396  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M535.362-60.299c-1.648,0.158-3.285,0.354-4.928,0.529c-1.639,0.189-3.289,0.337-4.919,0.558 l-5.958-48.564c1.844-0.247,3.684-0.417,5.526-0.628c1.841-0.196,3.684-0.414,5.525-0.591L535.362-60.299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M547.895-61.319c-1.658,0.119-3.321,0.215-4.974,0.351l-4.952,0.439l-4.456-48.724l5.519-0.488 c1.839-0.151,3.674-0.259,5.512-0.391L547.895-61.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M560.503-62.025l-4.998,0.244c-1.666,0.079-3.334,0.154-4.99,0.282l-3.071-48.831 c1.838-0.139,3.671-0.223,5.505-0.311l5.501-0.268L560.503-62.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M487.738-52.443l-4.688,1.17c-1.553,0.41-3.092,0.851-4.639,1.273L465.17-97.101 c1.833-0.502,3.664-1.023,5.499-1.507l5.511-1.378L487.738-52.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M499.72-55.082l-2.391,0.477c-0.799,0.153-1.593,0.32-2.379,0.504l-4.736,1.063l-11.132-47.645 l5.521-1.239c0.92-0.213,1.841-0.408,2.762-0.586l2.763-0.553L499.72-55.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M511.881-57.282c-1.626,0.23-3.22,0.554-4.831,0.825c-1.603,0.294-3.224,0.541-4.814,0.871 l-9.198-48.055c1.843-0.379,3.686-0.667,5.53-1.003c1.844-0.312,3.688-0.677,5.531-0.942L511.881-57.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M524.199-59.04l-4.894,0.64c-1.632,0.21-3.243,0.487-4.866,0.727l-7.429-48.361 c1.843-0.273,3.688-0.585,5.531-0.824l5.529-0.724L524.199-59.04z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M536.637-60.411c-1.655,0.131-3.293,0.323-4.935,0.502l-4.925,0.538l-5.796-48.583l5.525-0.605 c1.842-0.2,3.684-0.414,5.523-0.562L536.637-60.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M549.176-61.407l-4.977,0.34c-1.658,0.118-3.303,0.286-4.956,0.425l-4.311-48.738 c1.839-0.156,3.68-0.34,5.518-0.472l5.511-0.378L549.176-61.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M561.789-62.088l-9.994,0.502l-2.933-48.84c3.67-0.209,7.336-0.368,11.004-0.552L561.789-62.088z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M487.284-72.228c-0.929,0.212-1.861,0.41-2.787,0.633l-2.77,0.693l-7.126-28.689l3.046-0.76 c1.016-0.244,2.033-0.462,3.05-0.694L487.284-72.228z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "500.067,-74.893 494.454,-73.78 488.529,-102.741 494.639,-103.951  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "512.967,-77.041 507.303,-76.168 502.482,-105.332 508.595,-106.276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "538.99,-80.063 533.269,-79.556 530.382,-108.975 536.482,-109.516  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M552.077-81.003c-1.914,0.102-3.824,0.254-5.736,0.378l-2.039-29.49 c2.03-0.132,4.062-0.292,6.09-0.4L552.077-81.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M487.284-72.228c-1.378,0.307-2.757,0.611-4.121,0.966l-6.983-28.724 c1.503-0.389,3.01-0.723,4.517-1.06L487.284-72.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M500.082-74.896c-1.389,0.259-2.772,0.549-4.158,0.822l-5.795-28.987 c1.509-0.297,3.017-0.612,4.526-0.893L500.082-74.896z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "512.997,-77.045 508.801,-76.403 504.099,-105.587 508.628,-106.281  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E2D25"
    },
    points: "539.051,-80.068 534.813,-79.693 532.028,-109.122 536.546,-109.522  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M552.153-81.007c-1.419,0.065-2.833,0.185-4.249,0.275l-1.942-29.497 c1.503-0.095,3.01-0.221,4.51-0.291L552.153-81.007z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114782991440925318670000000285624642475273142_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M-46.91,99.036c37.862,25.94,90.497,21.597,116.438-16.258 C77.46,71.2,82.062,58.327,83.549,45.292c0.001-0.003,12.917-53.463-35.431-86.711C10.3-67.426-45.54-55.137-71.483-17.279 C-97.419,20.581-84.77,73.097-46.91,99.036z M-24.727,13.502c9.366-13.667,28.104-17.17,41.771-7.804 c13.667,9.366,17.169,28.104,7.804,41.771c-9.366,13.667-28.104,17.169-41.771,7.804 C-30.59,45.907-34.092,27.168-24.727,13.502z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M-28.973,76.057c23.319,16.121,55.463,9.847,71.652-13.988 C58.866,38.238,51.398,3.7,28.076-12.422C4.755-28.545-27.387-22.268-43.575,1.566C-59.764,25.4-52.294,59.935-28.973,76.057z  M-15.4,21.794c5.594-8.235,17.871-9.468,25.928-3.896c8.057,5.571,10.96,17.661,5.366,25.896 C10.3,52.028-3.595,54.119-11.653,48.548C-19.71,42.977-20.994,30.028-15.4,21.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#F3832E"
    },
    d: "M43.507,81.291c0,0-46.158,34.172-87.29-0.747 C-43.783,80.544-7.227,122.891,43.507,81.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#F3832E"
    },
    d: "M40.454-22.121c0,0-47.421-32.397-87.199,4.057 C-46.745-18.064-11.822-61.766,40.454-22.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#F3832E"
    },
    d: "M-30.069,81.471c0,0-46.436-29.449-23.202-74.773 C-53.271,6.698-85.285,49.525-30.069,81.471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#F3832E"
    },
    d: "M49.665,71.232c0,0,37.585-40.135,3.746-78.2 C53.411-6.968,95.126,26.481,49.665,71.232z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114782991440925318670000000285624642475273142_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M146.165-59.202c-0.38,1.853,0.025,3.502,0.905,3.682c0.88,0.181,1.902-1.175,2.283-3.028 c0.38-1.853-0.025-3.502-0.905-3.683C147.568-62.411,146.546-61.056,146.165-59.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M148.691-71.506c-0.38,1.854,0.025,3.502,0.905,3.683c0.88,0.181,1.902-1.175,2.283-3.028 c0.381-1.853-0.025-3.502-0.905-3.683C150.094-74.715,149.072-73.359,148.691-71.506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M151.217-83.81c-0.381,1.853,0.025,3.502,0.905,3.683c0.88,0.181,1.902-1.175,2.282-3.028 c0.381-1.854-0.025-3.502-0.905-3.683C152.62-87.019,151.598-85.663,151.217-83.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M105.283-67.595c-0.38,1.853,0.025,3.502,0.905,3.683c0.88,0.181,1.903-1.175,2.283-3.029 c0.381-1.853-0.024-3.502-0.905-3.683C106.686-70.805,105.664-69.449,105.283-67.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M107.81-79.899c-0.381,1.853,0.025,3.502,0.905,3.682c0.88,0.181,1.902-1.175,2.283-3.028 c0.38-1.853-0.025-3.502-0.905-3.683C109.212-83.108,108.19-81.752,107.81-79.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M110.335-92.203c-0.38,1.853,0.025,3.502,0.905,3.683c0.88,0.181,1.902-1.175,2.283-3.028 c0.38-1.854-0.025-3.502-0.905-3.683C111.738-95.412,110.716-94.056,110.335-92.203z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.301,
    y: -88.613,
    transform: "matrix(-0.9796 -0.2011 0.2011 -0.9796 279.636 -147.7895)",
    style: {
      fill: "#F3832E"
    },
    width: 42.02,
    height: 1.028
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.683,
    y: -75.862,
    transform: "matrix(-0.9796 -0.2011 0.2011 -0.9796 271.8897 -123.0736)",
    style: {
      fill: "#F3832E"
    },
    width: 42.02,
    height: 1.028
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.065,
    y: -63.111,
    transform: "matrix(-0.9796 -0.2011 0.2011 -0.9796 264.1426 -98.36)",
    style: {
      fill: "#F3832E"
    },
    width: 42.02,
    height: 1.028
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B81E"
    },
    d: "M-2.294,198.294c2.507-6.231,5.845-12.157,9.888-17.595 c7.852-10.562,23.348-20.327,26.249-33.178c3.319-14.701-2.294-30.589,0.255-45.51c2.305-13.487,8.98-23.811,18.306-30.466 c21.285-15.19,58.547-8.09,77.888,8.406c10.094,8.609,16.502,21.441,15.619,34.165c-0.79,11.388-6.9,20.91-11.53,30.971 c-4.624,10.049-5.462,22.022-2.693,32.686c1.674,6.447,4.622,12.485,6.796,18.781c7.727,22.38,5.462,51.869-8.159,71.685 c-18.347,26.692-59.901,31.502-89.746,20.415c-12.021-4.466-22.51-8.773-31.095-18.649 c-8.029-9.237-13.665-20.584-15.936-32.624C-8.956,224.104-7.246,210.603-2.294,198.294z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 92.33,
    y: -64.338,
    transform: "matrix(-0.9796 -0.2011 0.2011 -0.9796 198.2815 112.0701)",
    style: {
      fill: "#F3832E"
    },
    width: 25.006,
    height: 220.603
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B81E"
    },
    d: "M117.26-94.989c0.677-3.011,3.073-1.756,5.107-1.55c7.491,0.761,15.29,2.359,22.498,4.619 c1.951,0.612,4.647,0.403,4.083,3.437c-1.801,9.69-4.017,19.304-6.637,28.801c-0.681,2.47-1.443,5.033-3.099,6.915 c-2.029,2.307-4.842,3.113-7.349,4.63c-2.394,1.449-4.92,2.633-7.522,3.527c-0.307,0.105-0.688,0.178-0.9-0.06 c-0.29,0.135-0.611-0.082-0.852-0.3c-2.04-1.847-3.894-3.93-5.524-6.205c-1.706-2.381-3.974-4.23-4.93-7.151 c-0.78-2.382-0.471-5.038-0.124-7.577C113.346-75.663,115.097-85.372,117.26-94.989z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M80.972,198.275c10.079-1.143,18.221-8.59,20.262-18.534 c2.592-12.628-5.571-25.01-18.198-27.605c-2.431-0.497-4.899-0.61-7.341-0.333c-10.078,1.142-18.221,8.59-20.262,18.534 c-1.257,6.118-0.055,12.358,3.383,17.573c3.437,5.213,8.699,8.777,14.815,10.032C76.061,198.44,78.532,198.552,80.972,198.275z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M75.812,152.853c2.33-0.264,4.689-0.156,7.01,0.32c5.841,1.199,10.865,4.601,14.147,9.579 c3.282,4.978,4.43,10.936,3.23,16.777c-1.949,9.495-9.724,16.606-19.346,17.697c-2.33,0.264-4.689,0.157-7.01-0.32 c-5.841-1.199-10.865-4.601-14.147-9.579c-3.282-4.978-4.43-10.936-3.23-16.777C58.416,161.056,66.19,153.944,75.812,152.853 L75.812,152.853 M75.574,150.753c-10.223,1.159-18.996,8.747-21.177,19.372c-2.714,13.22,5.802,26.136,19.021,28.85 c2.594,0.533,5.177,0.633,7.673,0.35c10.223-1.159,18.996-8.746,21.177-19.372c2.714-13.22-5.802-26.136-19.021-28.85 C80.654,150.571,78.07,150.471,75.574,150.753L75.574,150.753z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M131.715-65.494c-0.185,0.902,0.396,1.783,1.298,1.968c0.902,0.185,1.783-0.396,1.969-1.298 c0.185-0.902-0.396-1.783-1.298-1.968C132.781-66.977,131.9-66.396,131.715-65.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M128.964-69.404c-0.185,0.902,0.396,1.783,1.298,1.969c0.902,0.185,1.783-0.396,1.968-1.298 c0.185-0.902-0.396-1.783-1.298-1.968C130.03-70.886,129.149-70.305,128.964-69.404z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M71.236,236.06c0.173-0.019,0.32-0.146,0.356-0.325L133.54-64.712 c0.046-0.223-0.098-0.44-0.32-0.485c-0.222-0.045-0.44,0.098-0.485,0.32L70.787,235.567c-0.046,0.224,0.098,0.441,0.32,0.486 C71.151,236.062,71.194,236.064,71.236,236.06z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M134.96-62.249c-0.185,0.902,0.396,1.783,1.298,1.968c0.902,0.185,1.783-0.396,1.969-1.298 c0.185-0.902-0.396-1.783-1.298-1.968C136.026-63.732,135.145-63.151,134.96-62.249z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M74.481,239.305c0.173-0.019,0.319-0.146,0.356-0.325l61.947-300.446 c0.046-0.223-0.098-0.44-0.32-0.485c-0.222-0.045-0.44,0.098-0.485,0.32L74.032,238.812c-0.046,0.224,0.098,0.441,0.32,0.486 C74.396,239.307,74.439,239.309,74.481,239.305z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M67.856,234.881c0.173-0.019,0.32-0.146,0.356-0.325L130.58-67.937 c0.046-0.223-0.098-0.44-0.32-0.485c-0.225-0.047-0.439,0.097-0.485,0.32l-62.368,302.49c-0.046,0.224,0.097,0.441,0.32,0.486 C67.771,234.883,67.814,234.885,67.856,234.881z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M64.249,234.004c0.172-0.019,0.319-0.146,0.356-0.325l63.127-306.193 c0.046-0.223-0.097-0.44-0.32-0.485c-0.223-0.045-0.439,0.098-0.485,0.32L63.8,233.512c-0.046,0.223,0.097,0.441,0.32,0.486 C64.163,234.007,64.207,234.009,64.249,234.004z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M60.523,233.862c0.173-0.02,0.32-0.146,0.356-0.325l63.797-309.461 c0.046-0.223-0.098-0.44-0.32-0.485c-0.223-0.048-0.439,0.097-0.485,0.32L60.075,233.369c-0.046,0.224,0.097,0.441,0.32,0.486 C60.438,233.863,60.481,233.866,60.523,233.862z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M57.258,233.189c0.173-0.019,0.32-0.146,0.356-0.325l64.522-312.986 c0.046-0.222-0.098-0.44-0.32-0.485c-0.225-0.047-0.44,0.097-0.485,0.32L56.809,232.697c-0.046,0.224,0.097,0.441,0.32,0.486 C57.172,233.191,57.215,233.194,57.258,233.189z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M125.904-73.502c-0.185,0.902,0.396,1.783,1.298,1.968c0.902,0.185,1.783-0.396,1.968-1.298 c0.185-0.902-0.396-1.783-1.298-1.968C126.97-74.985,126.089-74.404,125.904-73.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M122.903-77.174c-0.185,0.902,0.396,1.783,1.298,1.968c0.902,0.185,1.783-0.396,1.968-1.298 c0.185-0.902-0.396-1.783-1.298-1.968C123.97-78.657,123.088-78.076,122.903-77.174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M120.296-81.385c-0.185,0.902,0.396,1.783,1.298,1.968c0.902,0.185,1.783-0.396,1.968-1.298 c0.185-0.902-0.396-1.783-1.298-1.968C121.362-82.868,120.481-82.287,120.296-81.385z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M82.585,236.001c1.176,0.675,2.187,1.531,2.876,2.65c0.345,0.562,0.622,1.197,0.594,1.856 c-0.154,3.715-4.838,2.46-7.054,2.193c-3.466-0.418-30.111-5.295-32.727-7.647c-2.422-2.177,0.014-5.547,2.778-5.991 c4.331-0.697,8.74,0.864,12.963,1.456c4.301,0.603,8.626,1.983,12.859,2.963C77.252,234.031,80.243,234.657,82.585,236.001z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114782991440925318670000000285624642475273142_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M680.025,527.924c37.862,25.94,90.497,21.597,116.438-16.258 c7.932-11.578,12.534-24.451,14.021-37.486c0.001-0.003,12.917-53.463-35.431-86.711c-37.818-26.007-93.658-13.718-119.6,24.14 C629.517,449.469,642.166,501.984,680.025,527.924z M702.209,442.389c9.366-13.667,28.104-17.17,41.771-7.804 c13.667,9.366,17.169,28.104,7.804,41.771c-9.366,13.667-28.104,17.169-41.771,7.804 C696.346,474.794,692.843,456.056,702.209,442.389z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M697.963,504.944c23.319,16.121,55.463,9.847,71.652-13.988 c16.187-23.831,8.719-58.369-14.603-74.491c-23.321-16.122-55.463-9.846-71.652,13.988S674.642,488.822,697.963,504.944z  M711.535,450.681c5.594-8.235,17.871-9.468,25.929-3.897c8.057,5.571,10.96,17.661,5.366,25.896 c-5.594,8.235-19.489,10.326-27.547,4.755C707.226,471.864,705.942,458.916,711.535,450.681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#F3832E"
    },
    d: "M770.443,510.179c0,0-46.158,34.172-87.29-0.747 C683.152,509.432,719.708,551.778,770.443,510.179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#F3832E"
    },
    d: "M767.39,406.767c0,0-47.421-32.397-87.199,4.057 C680.191,410.824,715.114,367.121,767.39,406.767z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#F3832E"
    },
    d: "M696.867,510.358c0,0-46.436-29.449-23.202-74.773 C673.664,435.586,641.651,478.412,696.867,510.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#F3832E"
    },
    d: "M776.601,500.12c0,0,37.585-40.135,3.746-78.2 C780.347,421.92,822.061,455.369,776.601,500.12z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114782991440925318670000000285624642475273142_)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 613.916,
    y: 322.818,
    transform: "matrix(0.4115 -0.9114 0.9114 0.4115 93.6546 793.5544)",
    style: {
      fill: "#F3832E"
    },
    width: 94.728,
    height: 2.885
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.859,
    y: 312.918,
    transform: "matrix(0.2917 -0.9565 0.9565 0.2917 204.0761 904.3251)",
    style: {
      fill: "#F3832E"
    },
    width: 107.643,
    height: 2.886
  }), /*#__PURE__*/React.createElement("rect", {
    x: 718.472,
    y: 268.561,
    transform: "matrix(0.2844 -0.9587 0.9587 0.2844 252.313 885.3538)",
    style: {
      fill: "#F3832E"
    },
    width: 1.443,
    height: 10.218
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710.649,
    y: 294.354,
    transform: "matrix(0.2843 -0.9587 0.9587 0.2843 222.0094 896.3314)",
    style: {
      fill: "#F3832E"
    },
    width: 1.443,
    height: 10.218
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.825,
    y: 320.149,
    transform: "matrix(0.2844 -0.9587 0.9587 0.2844 191.63 907.2472)",
    style: {
      fill: "#F3832E"
    },
    width: 1.443,
    height: 10.218
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.001,
    y: 345.942,
    transform: "matrix(0.2844 -0.9587 0.9587 0.2844 161.2769 918.1793)",
    style: {
      fill: "#F3832E"
    },
    width: 1.443,
    height: 10.218
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 681.319,
    y: 288.23,
    transform: "matrix(0.4067 -0.9136 0.9136 0.4067 137.2149 796.7906)",
    style: {
      fill: "#F3832E"
    },
    width: 1.442,
    height: 9.054
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 671.468,
    y: 309.994,
    transform: "matrix(0.4067 -0.9136 0.9136 0.4067 111.4726 800.6887)",
    style: {
      fill: "#F3832E"
    },
    width: 1.442,
    height: 9.054
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 661.617,
    y: 331.759,
    transform: "matrix(0.4066 -0.9136 0.9136 0.4066 85.7942 804.6633)",
    style: {
      fill: "#F3832E"
    },
    width: 1.442,
    height: 9.054
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 651.766,
    y: 353.524,
    transform: "matrix(0.4068 -0.9135 0.9135 0.4068 59.9876 808.4778)",
    style: {
      fill: "#F3832E"
    },
    width: 1.442,
    height: 9.054
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B81E"
    },
    d: "M588.083,361.942c2.46-10.939,4.627-21.953,6.8-32.958c3.063-15.516,5.757-36.92-4.101-53.574 l61.343-13.056c1.831,23.163,1.581,43.114-3.049,61.63c-4.749,18.992-11.979,33.003-17.467,50.294 c-1.76,5.545-4.353,11.103-4.464,17.018c-0.132,7.056,6.835,9.562,11.771,6.369c1.409-0.912,2.415-2.327,3.081-3.866 l77.942-180.15c7.41-16.399,18.961-18.519,31.228-18.831c3.97-0.101,36.246-0.712,53.278-0.914 c-0.077,2.133-0.089,4.199-0.099,6.086c-15.214,1.477-43.29,4.319-51.663,5.61c-8.306,1.28-15.603,5.654-19.721,17.674 l-55.622,182.356c-4.138,11.295-11.615,21.417-22.125,27.54c-10.892,6.345-24.225,7.935-36.293,4.202 c-12.067-3.733-24.616-13.849-29.797-25.24C581.637,395.67,584.271,378.898,588.083,361.942z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M592.929,363.624c-6.23-0.732-11.875,3.713-12.608,9.93 c-0.734,6.216,3.722,11.849,9.953,12.582c6.23,0.733,11.875-3.713,12.608-9.93 C603.615,369.989,599.159,364.356,592.929,363.624z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M596.529,333.119c-6.23-0.732-11.875,3.713-12.609,9.93c-0.734,6.216,3.722,11.85,9.953,12.582 c6.23,0.733,11.875-3.713,12.608-9.93C607.214,339.484,602.758,333.851,596.529,333.119z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M600.127,302.614c-6.23-0.732-11.875,3.713-12.608,9.93s3.722,11.85,9.953,12.582 c6.23,0.732,11.875-3.713,12.609-9.93C610.813,308.98,606.357,303.347,600.127,302.614z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M703.73,253.675c2.773,1.201,5.997-0.067,7.2-2.834c1.204-2.767-0.068-5.984-2.841-7.185 c-2.773-1.202-5.997,0.068-7.2,2.834C699.685,249.257,700.957,252.474,703.73,253.675z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M697.823,267.252c2.773,1.201,5.997-0.068,7.201-2.834c1.204-2.767-0.068-5.983-2.841-7.185 c-2.773-1.202-5.997,0.067-7.2,2.834C693.778,262.833,695.05,266.05,697.823,267.252z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M691.916,280.828c2.773,1.202,5.997-0.068,7.201-2.834c1.204-2.767-0.068-5.983-2.841-7.185 c-2.773-1.201-5.997,0.068-7.2,2.834C687.871,276.41,689.143,279.627,691.916,280.828z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M685.17,298.594c3.35,1.452,7.245-0.082,8.699-3.424c1.454-3.343-0.082-7.229-3.433-8.681 c-3.35-1.452-7.245,0.082-8.699,3.424C680.283,293.256,681.82,297.142,685.17,298.594z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M678.033,314.997c3.35,1.451,7.245-0.082,8.7-3.424c1.454-3.343-0.083-7.229-3.433-8.681 c-3.35-1.452-7.245,0.082-8.699,3.424C673.146,309.659,674.683,313.546,678.033,314.997z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M670.896,331.401c3.35,1.452,7.245-0.081,8.7-3.424c1.454-3.343-0.082-7.229-3.433-8.681 c-3.35-1.452-7.245,0.081-8.7,3.424C666.009,326.063,667.546,329.949,670.896,331.401z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M663.759,347.804c3.35,1.452,7.245-0.082,8.7-3.424c1.455-3.343-0.083-7.229-3.433-8.681 c-3.35-1.452-7.245,0.081-8.7,3.424C658.872,342.466,660.409,346.353,663.759,347.804z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M656.622,364.208c3.35,1.452,7.245-0.082,8.7-3.424c1.454-3.343-0.083-7.229-3.433-8.681 c-3.35-1.452-7.245,0.081-8.7,3.424C651.735,358.87,653.272,362.756,656.622,364.208z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M649.485,380.611c3.35,1.452,7.245-0.081,8.7-3.424c1.454-3.343-0.082-7.229-3.433-8.681 c-3.35-1.451-7.245,0.082-8.699,3.424C644.598,375.273,646.135,379.159,649.485,380.611z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F3832E"
    },
    points: "793.34,193.381 812.151,193.804 808.248,200.862 789.386,201.846  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F3832E"
    },
    points: "800.906,191.705 799.149,203.462 771.585,206.213 770.273,191.015  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M585.326,276.996c1.134,5.118,18.336,5.676,38.422,1.248c20.086-4.428,35.45-12.167,34.316-17.284 c-1.134-5.118-18.336-5.676-38.421-1.248C599.556,264.14,584.192,271.879,585.326,276.996z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114782991440925318670000000285624642475273142_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B81E"
    },
    d: "M375.272,426.99c0.981-2.962,4.626-4.456,8.144-3.184c3.516,1.269,5.486,4.813,4.407,7.756 c-1.078,2.946-4.727,4.198-8.148,2.95C376.256,433.259,374.29,429.957,375.272,426.99z M238.607,399.91 c2.844,0.633,4.943-1.035,4.605-3.716c-0.335-2.682-3.095-5.317-6.081-5.902c-2.988-0.585-4.953,1.055-4.474,3.689 C233.137,396.616,235.761,399.279,238.607,399.91z M331.285,411.295c3.358,0.803,6.64-0.923,7.279-3.96 c0.641-3.035-1.723-6.213-5.232-6.987c-3.51-0.776-6.707,1.113-7.197,4.118C325.647,407.475,327.926,410.49,331.285,411.295z  M282.874,401.238c3.128,0.596,5.812-1.232,5.923-4.122c0.113-2.891-2.515-5.7-5.795-6.236 c-3.282-0.536-5.849,1.345-5.809,4.174C277.234,397.886,279.743,400.642,282.874,401.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M223.207,406.364c3.168,19.741,2.947,38.893-0.015,56.919 c-1.709,11.092,25.977,31.476,64.426,42.979c37.533,10.531,80.033,13.576,86.948,4.362 c9.647-16.511,18.619-33.935,27.292-54.322C334.76,426.837,274.612,420.577,223.207,406.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M289.073,502.602c-35.178-10.387-61.252-27.687-65.891-39.175 c-1.453,11.117,26.146,31.382,64.437,42.835c36.102,10.23,76.323,13.098,85.982,5.543 C358.175,515.437,322.232,512.097,289.073,502.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9CA67"
    },
    d: "M401.859,456.302c-5.375,11.881-54.743,3.142-99.583-7.428 c-44.908-11.528-76.319-30.1-79.069-42.51c-2.559-11.616,31.856-14.583,86.649-5.24 C365.197,410.48,408.396,443.542,401.859,456.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M309.158,407.179c49.792,9.082,90.669,37.389,90.775,51.553c0.858-0.691,1.523-1.488,1.926-2.431 c6.536-12.76-36.662-45.822-92.004-55.178c-54.792-9.343-89.208-6.376-86.649,5.24c0.145,0.91,0.494,1.86,0.989,2.837 C226.774,399.951,259.66,397.977,309.158,407.179z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M281.303,442.664c-2.732,19.95-6.929,38.593-11.627,57.329c0.322,0.13,0.641,0.261,0.966,0.391 c4.725-18.745,8.974-37.385,11.786-57.342C282.049,442.918,281.678,442.79,281.303,442.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M242.319,425.255c0.425,19.717-1.856,38.383-5.822,56.554c0.293,0.224,0.6,0.449,0.902,0.674 c3.987-18.192,6.333-36.852,6.015-56.574C243.048,425.691,242.677,425.473,242.319,425.255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M323.229,453.776c-5.522,20.01-11.749,38.353-17.849,56.995 c0.356,0.075,0.708,0.145,1.064,0.219c6.154-18.625,12.444-36.951,18.044-56.957 C324.068,453.947,323.65,453.864,323.229,453.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M371.721,461.385c-8.026,19.732-16.492,37.155-24.993,54.551 c0.442,0.015,0.89,0.035,1.325,0.047c8.579-17.342,17.098-34.735,25.179-54.461C372.737,461.48,372.225,461.43,371.721,461.385 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B81E"
    },
    d: "M242.215,483.161c-0.525,2.439-2.864,3.769-5.192,2.961c-2.33-0.808-3.764-3.421-3.243-5.83 c0.521-2.409,2.795-3.731,5.129-2.953C241.242,478.118,242.741,480.723,242.215,483.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B81E"
    },
    d: "M354.024,517.317c-1.191,2.266-4.419,3.379-7.167,2.519c-2.749-0.863-4.063-3.434-2.973-5.773 c1.091-2.338,4.25-3.509,7.1-2.575C353.832,512.422,355.215,515.052,354.024,517.317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B81E"
    },
    d: "M275.911,499.966c-0.645,2.496-3.081,3.934-5.424,3.198c-2.344-0.737-3.736-3.362-3.13-5.849 c0.607-2.487,3.007-3.907,5.39-3.18C275.129,494.863,276.557,497.469,275.911,499.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B81E"
    },
    d: "M312.106,510.662c-0.859,2.46-3.558,3.882-6.013,3.17c-2.455-0.712-3.795-3.309-3.01-5.792 c0.785-2.483,3.451-3.903,5.98-3.167C311.593,505.608,312.966,508.202,312.106,510.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M401.859,456.302c6.536-12.759-36.662-45.822-92.004-55.178 c-54.792-9.343-89.208-6.376-86.649,5.24c2.75,12.41,34.161,30.982,79.069,42.51 C347.116,459.444,396.484,468.183,401.859,456.302z M302.873,445.98c-43.515-11.04-74.14-27.916-76.404-38.783 c-2.04-10.157,31.232-12.15,83.027-2.866c52.207,9.239,93.913,38.921,88.273,50.142 C393.106,464.927,346.359,456.224,302.873,445.98z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B81E"
    },
    d: "M246.935,426.088c0.009,2.625-2.12,4.179-4.671,3.484c-2.553-0.694-4.638-3.358-4.749-5.962 c-0.109-2.604,1.879-4.178,4.535-3.504C244.704,420.779,246.929,423.463,246.935,426.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B81E"
    },
    d: "M377.934,462.87c-1.107,2.603-4.634,3.662-7.841,2.49c-3.207-1.177-4.944-4.18-3.917-6.827 c1.027-2.644,4.502-3.901,7.791-2.682C377.255,457.067,379.043,460.268,377.934,462.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B81E"
    },
    d: "M286.498,442.208c-0.405,2.663-2.952,4.227-5.627,3.532c-2.676-0.696-4.548-3.381-4.247-6.03 c0.302-2.647,2.745-4.269,5.527-3.587C284.931,436.803,286.906,439.546,286.498,442.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B81E"
    },
    d: "M329.116,453.488c-0.785,2.662-3.816,4.099-6.719,3.283c-2.904-0.819-4.667-3.594-3.992-6.267 c0.676-2.67,3.624-4.223,6.639-3.395C328.056,447.936,329.903,450.827,329.116,453.488z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M245.536,424.55c0.015,1.05-0.826,1.678-1.864,1.404c-1.039-0.274-1.896-1.343-1.928-2.39 c-0.032-1.047,0.787-1.678,1.843-1.407C244.642,422.427,245.521,423.5,245.536,424.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M376.701,461.033c-0.437,1.049-1.849,1.491-3.147,1.006c-1.299-0.485-2.003-1.718-1.578-2.774 c0.425-1.056,1.829-1.53,3.14-1.038C376.428,458.718,377.139,459.984,376.701,461.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M285.218,440.643c-0.152,1.067-1.167,1.702-2.257,1.425c-1.09-0.277-1.855-1.36-1.72-2.424 c0.136-1.064,1.134-1.709,2.241-1.434C284.589,438.485,285.371,439.577,285.218,440.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M327.882,451.84c-0.305,1.069-1.518,1.657-2.701,1.324c-1.183-0.333-1.902-1.461-1.614-2.532 c0.288-1.071,1.488-1.677,2.688-1.343C327.456,449.624,328.188,450.771,327.882,451.84z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M240.667,481.401c-0.206,0.974-1.133,1.506-2.064,1.19c-0.931-0.317-1.516-1.361-1.311-2.33 c0.205-0.969,1.121-1.501,2.054-1.189C240.278,479.384,240.873,480.427,240.667,481.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M352.397,515.517c-0.467,0.913-1.759,1.358-2.878,0.999c-1.119-0.359-1.655-1.395-1.204-2.321 c0.451-0.925,1.732-1.38,2.867-1.009C352.317,513.557,352.864,514.603,352.397,515.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M274.387,498.219c-0.253,0.997-1.226,1.57-2.17,1.278c-0.944-0.292-1.506-1.339-1.26-2.335 c0.247-0.996,1.214-1.567,2.165-1.275C274.072,496.178,274.64,497.221,274.387,498.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M310.573,508.927c-0.337,0.986-1.42,1.551-2.415,1.262c-0.995-0.289-1.536-1.326-1.211-2.316 c0.325-0.99,1.402-1.555,2.41-1.262C310.364,506.904,310.91,507.942,310.573,508.927z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DE6DF"
    },
    d: "M286.693,359.459c-0.067-0.394-0.135-0.788-0.204-1.181 c31.564-2.244,67.634-1.138,107.294,6.106c-0.028,0.454-0.057,0.908-0.087,1.362 C354.142,358.445,318.168,357.279,286.693,359.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M285.209,356.015c2.861-0.223,5.471,1.044,5.745,2.799c0.277,1.755-1.846,3.304-4.655,3.491 c-2.811,0.186-5.287-1.034-5.615-2.753C280.359,357.833,282.347,356.237,285.209,356.015z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DE6DF"
    },
    d: "M352.687,398.762c-0.322,0.298-0.643,0.597-0.965,0.895 c-22.583-26.187-50.423-47.833-81.979-63.445c0.154-0.321,0.307-0.642,0.461-0.964 C301.926,350.848,329.938,372.516,352.687,398.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E2D25"
    },
    d: "M350.415,402.131c-1.991-2.357-2.535-5.306-1.154-6.638c1.38-1.33,4.241-0.515,6.326,1.876 c2.087,2.389,2.532,5.421,1.057,6.717C355.168,405.384,352.407,404.486,350.415,402.131z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114782991440925318670000000285624642475273142_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M970.945,80.934c-11.327,0-24.76-1.956-33.288-4.409c-1.332-0.383-2.591-0.753-3.794-1.106 c-16.192-4.753-22.25-6.532-62.828,1.211c-0.969,0.185-1.941,0.379-2.931,0.577c-6.749,1.347-14.399,2.874-27.815,2.874 c-15.388,0-23.204-1.756-30.762-3.454c-7.361-1.653-14.974-3.362-29.946-3.362c-14.971,0-22.583,1.709-29.944,3.362 c-7.558,1.698-15.374,3.454-30.76,3.454c-15.387,0-23.202-1.756-30.76-3.454c-7.361-1.653-14.974-3.362-29.943-3.362v-1 c15.081,0,22.747,1.722,30.162,3.387c7.505,1.686,15.265,3.429,30.541,3.429c15.276,0,23.036-1.743,30.542-3.429 c7.415-1.665,15.081-3.387,30.163-3.387c15.083,0,22.75,1.722,30.164,3.387c7.506,1.686,15.267,3.429,30.544,3.429 c13.317,0,20.915-1.517,27.619-2.854c0.993-0.198,1.967-0.393,2.94-0.578c40.815-7.788,46.937-5.991,63.298-1.188 c1.201,0.353,2.458,0.722,3.789,1.104c11.101,3.193,30.578,5.54,42.685,3.758c8.64-1.27,19.306-3.161,31.701-5.622 c28.02-5.562,44.6-1.375,57.924,1.99c7.201,1.819,13.42,3.39,19.549,2.657l0.119,0.993c-6.312,0.75-12.615-0.838-19.913-2.681 c-13.227-3.34-29.688-7.496-57.483-1.979c-12.412,2.464-23.095,4.358-31.752,5.63 C977.842,80.742,974.496,80.934,970.945,80.934z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M970.945,94.605c-11.327,0-24.76-1.956-33.288-4.409c-1.332-0.383-2.591-0.753-3.794-1.106 c-16.193-4.752-22.251-6.532-62.828,1.212c-0.971,0.185-1.944,0.379-2.936,0.577c-6.749,1.347-14.398,2.873-27.81,2.873 c-15.383,0-23.202-1.756-30.762-3.454c-7.361-1.653-14.974-3.362-29.946-3.362c-14.971,0-22.583,1.709-29.944,3.362 c-7.56,1.698-15.378,3.454-30.76,3.454c-15.383,0-23.2-1.756-30.76-3.454c-7.361-1.653-14.974-3.362-29.943-3.362v-1 c15.081,0,22.747,1.722,30.162,3.387c7.507,1.686,15.269,3.429,30.541,3.429c15.271,0,23.034-1.743,30.541-3.429 c7.415-1.665,15.082-3.387,30.164-3.387c15.083,0,22.75,1.722,30.164,3.387c7.508,1.686,15.271,3.429,30.544,3.429 c13.314,0,20.911-1.516,27.614-2.854c0.995-0.198,1.971-0.393,2.944-0.579c40.815-7.788,46.937-5.992,63.297-1.189 c1.202,0.353,2.459,0.722,3.79,1.104c11.101,3.194,30.578,5.54,42.685,3.759c8.644-1.271,19.31-3.163,31.701-5.622 c28.02-5.561,44.601-1.374,57.923,1.99c7.201,1.819,13.421,3.39,19.55,2.657l0.119,0.993 c-6.313,0.756-12.616-0.838-19.914-2.681c-13.226-3.34-29.684-7.496-57.482-1.979c-12.408,2.463-23.091,4.357-31.752,5.631 C977.842,94.413,974.496,94.605,970.945,94.605z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M970.947,108.275c-11.328,0-24.762-1.956-33.29-4.409c-1.333-0.383-2.592-0.753-3.795-1.106 c-16.192-4.754-22.252-6.531-62.827,1.212c-0.971,0.185-1.944,0.379-2.936,0.577c-6.749,1.347-14.398,2.873-27.81,2.873 c-15.383,0-23.202-1.756-30.762-3.454c-7.363-1.653-14.976-3.363-29.946-3.363c-14.969,0-22.581,1.709-29.943,3.363 c-7.562,1.698-15.379,3.454-30.762,3.454c-15.383,0-23.2-1.756-30.76-3.454c-7.364-1.653-14.976-3.363-29.943-3.363v-1 c15.079,0,22.745,1.722,30.16,3.387c7.509,1.687,15.271,3.43,30.544,3.43c15.271,0,23.034-1.743,30.541-3.429 c7.417-1.666,15.084-3.387,30.164-3.387c15.081,0,22.749,1.722,30.164,3.387c7.508,1.686,15.271,3.429,30.544,3.429 c13.314,0,20.911-1.516,27.614-2.854c0.995-0.198,1.971-0.393,2.944-0.579c40.814-7.789,46.935-5.991,63.296-1.189 c1.202,0.353,2.459,0.722,3.791,1.104c11.102,3.193,30.575,5.536,42.685,3.759c8.644-1.271,19.31-3.163,31.701-5.622 c28.02-5.561,44.602-1.374,57.923,1.99c7.201,1.818,13.421,3.391,19.55,2.657l0.119,0.993 c-6.312,0.753-12.615-0.838-19.914-2.681c-13.225-3.339-29.688-7.494-57.482-1.979c-12.408,2.463-23.091,4.357-31.752,5.631 C977.843,108.083,974.497,108.275,970.947,108.275z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M970.945,121.946c-11.327,0-24.76-1.956-33.288-4.409c-1.332-0.383-2.591-0.753-3.794-1.106 c-16.192-4.753-22.25-6.532-62.828,1.211c-0.969,0.185-1.941,0.379-2.931,0.577c-6.749,1.347-14.399,2.873-27.815,2.873 c-15.388,0-23.204-1.756-30.762-3.454c-7.361-1.653-14.974-3.362-29.946-3.362c-14.971,0-22.583,1.709-29.944,3.362 c-7.558,1.698-15.374,3.454-30.76,3.454c-15.387,0-23.202-1.756-30.76-3.454c-7.361-1.653-14.974-3.362-29.943-3.362v-1 c15.081,0,22.747,1.722,30.162,3.387c7.505,1.686,15.265,3.429,30.541,3.429c15.276,0,23.036-1.743,30.542-3.429 c7.415-1.665,15.081-3.387,30.163-3.387c15.083,0,22.75,1.722,30.164,3.387c7.506,1.686,15.267,3.429,30.544,3.429 c13.317,0,20.915-1.517,27.619-2.854c0.993-0.198,1.967-0.393,2.94-0.578c40.815-7.788,46.937-5.991,63.298-1.188 c1.201,0.353,2.458,0.722,3.789,1.104c11.101,3.193,30.578,5.539,42.685,3.758c8.64-1.27,19.306-3.161,31.701-5.622 c28.02-5.562,44.6-1.374,57.924,1.99c7.201,1.818,13.42,3.391,19.549,2.657l0.119,0.993 c-6.312,0.751-12.615-0.838-19.913-2.681c-13.227-3.34-29.688-7.497-57.483-1.979c-12.412,2.464-23.095,4.358-31.752,5.63 C977.842,121.754,974.496,121.946,970.945,121.946z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M970.946,135.617c-11.329,0.001-24.761-1.956-33.289-4.409 c-1.332-0.383-2.591-0.753-3.794-1.106c-16.193-4.752-22.251-6.532-62.828,1.212c-0.971,0.185-1.944,0.379-2.936,0.577 c-6.749,1.347-14.398,2.873-27.81,2.873c-15.383,0-23.202-1.756-30.762-3.454c-7.363-1.653-14.976-3.363-29.946-3.363 c-14.969,0-22.581,1.71-29.943,3.363c-7.562,1.698-15.379,3.454-30.762,3.454c-15.383,0-23.2-1.756-30.76-3.454 c-7.364-1.653-14.976-3.363-29.943-3.363v-1c15.079,0,22.745,1.722,30.16,3.387c7.509,1.686,15.271,3.43,30.544,3.43 c15.271,0,23.034-1.743,30.541-3.429c7.417-1.666,15.084-3.387,30.164-3.387c15.081,0,22.749,1.722,30.164,3.387 c7.508,1.686,15.271,3.429,30.544,3.429c13.314,0,20.911-1.516,27.614-2.854c0.995-0.198,1.971-0.393,2.944-0.579 c40.815-7.788,46.937-5.992,63.297-1.189c1.202,0.353,2.459,0.722,3.79,1.105c11.1,3.193,30.574,5.54,42.685,3.759 c8.644-1.271,19.31-3.163,31.701-5.622c28.02-5.562,44.601-1.374,57.923,1.99c7.201,1.818,13.421,3.39,19.55,2.657l0.119,0.993 c-6.313,0.754-12.616-0.838-19.914-2.681c-13.226-3.339-29.684-7.495-57.482-1.979c-12.408,2.463-23.091,4.357-31.752,5.631 C977.842,135.424,974.496,135.617,970.946,135.617z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114782991440925318670000000285624642475273142_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBC49"
    },
    d: "M692.688-49.343c21.129-10.666,46.996-2.154,57.663,18.975 c10.666,21.129,2.155,46.997-18.974,57.663c-21.129,10.666-46.996,2.154-57.663-18.975 C663.047-12.809,671.559-38.676,692.688-49.343z M727.363,19.345c16.745-8.453,23.491-28.954,15.038-45.7 c-8.454-16.746-28.954-23.492-45.7-15.038c-16.745,8.453-23.491,28.954-15.038,45.7 C690.117,21.052,710.618,27.799,727.363,19.345z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBC49"
    },
    d: "M686.374,20.373l53.892-27.206c6.422-3.242,8.555-9.33,5.436-15.51 c-3.12-6.18-9.285-8.079-15.707-4.837L677.102-0.478l2.924,5.793l52.893-26.702c3.215-1.623,5.502-0.979,6.99,1.968 c1.488,2.947,0.648,5.169-2.567,6.792L683.45,14.58L686.374,20.373z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B81E"
    },
    d: "M696.196,15.415l-8.798,4.442c-0.836-0.721-1.646-1.478-2.429-2.268l-1.519-3.008 l7.385-3.728C692.474,12.57,694.272,14.096,696.196,15.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B81E"
    },
    d: "M685.112,2.747l-5.087,2.568l-2.924-5.793l5.642-2.848c0.582,2.05,1.359,4.076,2.355,6.048 C685.103,2.73,685.108,2.738,685.112,2.747z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 719.804,
    y: -30.34,
    transform: "matrix(-0.8927 0.4507 -0.4507 -0.8927 1360.2059 -353.8076)",
    style: {
      fill: "#F3832E"
    },
    width: 4.843,
    height: 30.753
  }), /*#__PURE__*/React.createElement("rect", {
    x: 711.835,
    y: -30.869,
    transform: "matrix(-0.8927 0.4506 -0.4506 -0.8927 1341.0725 -376.4607)",
    style: {
      fill: "#F3832E"
    },
    width: 7.037,
    height: 4.585
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 710.082,
    y: -25.433,
    transform: "matrix(-0.8927 0.4507 -0.4507 -0.8927 1344.0176 -340.1375)",
    style: {
      fill: "#F3832E"
    },
    width: 4.843,
    height: 30.753
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.113,
    y: -25.962,
    transform: "matrix(-0.8927 0.4507 -0.4507 -0.8927 1324.882 -362.7946)",
    style: {
      fill: "#F3832E"
    },
    width: 7.037,
    height: 4.585
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 700.361,
    y: -20.525,
    transform: "matrix(-0.8927 0.4506 -0.4506 -0.8927 1327.8384 -326.4501)",
    style: {
      fill: "#F3832E"
    },
    width: 4.843,
    height: 30.753
  }), /*#__PURE__*/React.createElement("rect", {
    x: 692.392,
    y: -21.054,
    transform: "matrix(-0.8927 0.4507 -0.4507 -0.8927 1308.6934 -349.1247)",
    style: {
      fill: "#F3832E"
    },
    width: 7.037,
    height: 4.585
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBC49"
    },
    d: "M692.688-49.343c21.129-10.666,46.996-2.154,57.663,18.975 c10.666,21.129,2.155,46.997-18.974,57.663c-21.129,10.666-46.996,2.154-57.663-18.975 C663.047-12.809,671.559-38.676,692.688-49.343z M727.363,19.345c16.745-8.453,23.491-28.954,15.038-45.7 c-8.454-16.746-28.954-23.492-45.7-15.038c-16.745,8.453-23.491,28.954-15.038,45.7 C690.117,21.052,710.618,27.799,727.363,19.345z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#F7B81E"
    },
    d: "M706.216,22.459c6.966,1.221,14.362,0.311,21.147-3.114 c12.213-6.166,19.098-18.74,18.656-31.592c-1.111,2.172-3.045,4.048-5.752,5.414l-1.431,0.722 c0.806-2.861,1.226-5.832,1.246-8.832c0.75-1.259,0.704-2.738-0.173-4.476c-0.041-0.08-0.088-0.14-0.13-0.217 c-0.416-3.053-1.258-6.092-2.568-9.032c1.846,0.204,3.558,0.89,5.042,2.039c-2.434-4.715-5.831-8.621-9.826-11.607l-6.805-13.479 c5.024,1.678,9.737,4.28,13.868,7.709l4.97,9.846c10.507,20.813,2.152,46.202-18.661,56.709l-18.053,9.114 c-4.489-0.458-8.879-1.607-12.997-3.415L706.216,22.459z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B81E"
    },
    d: "M727.363,19.345c-3.036,1.533-6.197,2.559-9.386,3.124c3.845-0.452,7.675-1.572,11.327-3.415 c16.745-8.453,23.491-28.954,15.038-45.7c-6.921-13.709-21.916-20.71-36.314-18.162c13.787-1.62,27.763,5.359,34.374,18.453 C750.854-9.609,744.108,10.892,727.363,19.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B81E"
    },
    d: "M675.654,8.029c-10.666-21.129-2.155-46.997,18.975-57.663c3.858-1.948,7.875-3.249,11.928-3.958 c-4.709,0.601-9.395,1.991-13.869,4.249c-21.129,10.666-29.641,36.534-18.974,57.663c8.719,17.271,27.593,26.105,45.735,22.933 C701.916,33.491,684.062,24.685,675.654,8.029z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B81E"
    },
    d: "M669.823,117.789l-0.002,0.019l-0.007-0.014c-0.042,0.031-0.085,0.06-0.13,0.084 c-3.572,1.803-18.249-20.073-32.782-48.863c-14.533-28.789-23.42-53.589-19.848-55.392c0.046-0.023,0.095-0.04,0.145-0.056 l-0.007-0.014l0.016,0.01c0.504-0.151,1.195,0.097,2.046,0.705c3.365,2.403,6.716,4.826,10.213,7.034l21.211,13.39 c12.221,7.715,27.595,8.45,40.497,1.937l38.143-19.255c16.422-8.29,23.014-28.323,14.724-44.745l-22.64-44.847l-7.94-3.1 l18.072-9.123l-2.204,8.165l22.662,44.891c10.507,20.813,2.152,46.202-18.661,56.708l-38.143,19.256 c-12.902,6.513-21.44,19.319-22.49,33.734l-1.822,25.017c-0.3,4.124-0.341,8.259-0.406,12.394 C670.455,116.77,670.244,117.472,669.823,117.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#F7B81E"
    },
    d: "M642.7,33.873c-0.548,0.485,7.547,13.365,11.688,22.523 c8.573,18.961,12.337,32.756,13.158,32.425c0.647-0.26-3.008-16.693,0.336-25.516c3.239-8.546,10.573-13.573,8.506-15.702 c-0.679-0.7-10.023,2.257-19.459-1.871C647.605,41.655,643.28,33.36,642.7,33.873z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M607.431,181.81c-4.962-3.726-14.579-0.848-14.579-0.848l-2.117,12.997 c-1.144-0.582-2.537-0.95-4.038-0.593c-3.871,0.92-5.366,6.162-1.6,8.16c0.991,0.526,1.995,0.666,2.943,0.58 c2.927-0.265,5.213-2.667,5.657-5.572l0.031-0.199l0,0l2.043-13.353c7.648-0.543,8.174,1.669,8.174,1.669 c-3.61-0.335-4.162,5.043-0.711,5.176C608.273,190.022,607.431,181.81,607.431,181.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M93.975,395.477c-4.962-3.726-14.579-0.848-14.579-0.848l-2.117,12.997 c-1.144-0.582-2.537-0.95-4.038-0.593c-3.871,0.92-5.366,6.162-1.6,8.16c0.991,0.526,1.995,0.666,2.943,0.58 c2.927-0.265,5.213-2.667,5.657-5.572l0.03-0.199l0,0l2.043-13.353c7.648-0.544,8.174,1.669,8.174,1.669 c-3.61-0.335-4.162,5.043-0.711,5.176C94.817,403.689,93.975,395.477,93.975,395.477z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M195.568,428.513c-6.103-1.125-13.431,5.735-13.431,5.735l3.895,12.579 c-1.284-0.011-2.695,0.28-3.88,1.269c-3.056,2.548-2.059,7.908,2.203,8.018c1.121,0.029,2.083-0.293,2.894-0.792 c2.502-1.541,3.479-4.71,2.583-7.509l-0.061-0.192l0,0l-4.12-12.865c6.605-3.894,8.062-2.147,8.062-2.147 c-3.381,1.309-1.48,6.369,1.67,4.951C199.98,435.49,195.568,428.513,195.568,428.513z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M232.622,114.657c-4.894-3.598-14.277-0.686-14.277-0.686l-1.943,12.742 c-1.126-0.558-2.493-0.904-3.958-0.54c-3.78,0.938-5.191,6.084-1.485,8.002c0.975,0.505,1.959,0.632,2.887,0.538 c2.862-0.288,5.075-2.662,5.481-5.509l0.028-0.195l0,0l1.867-13.089c7.48-0.608,8.017,1.552,8.017,1.552 c-3.536-0.292-4.023,4.977-0.644,5.073C233.527,122.686,232.622,114.657,232.622,114.657z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M634.342,238.107l-0.086-0.344c0,0-3.13-9.817-4.3-17.622c-0.315-2.101-0.527-4.984-0.527-4.984 l0,0c-3.33,1.685-0.558,13.843-0.558,13.843l1.862,7.772c-1.28-0.095-2.707,0.104-3.954,1.013 c-3.216,2.344-2.569,7.757,1.676,8.145c1.335,0.122,2.46-0.275,3.383-0.893C634.068,243.545,634.992,240.712,634.342,238.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M145.788,434.113l-0.086-0.344c0,0-3.131-9.817-4.3-17.622c-0.315-2.101-0.527-4.984-0.527-4.984 l0,0c-3.33,1.685-0.558,13.843-0.558,13.843l1.862,7.772c-1.28-0.095-2.707,0.104-3.954,1.013 c-3.215,2.344-2.569,7.757,1.676,8.145c1.335,0.122,2.46-0.275,3.383-0.893C145.514,439.551,146.438,436.718,145.788,434.113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M393.045,77.669l-0.086-0.343c0,0-3.123-9.792-4.29-17.578c-0.314-2.095-0.526-4.971-0.526-4.971 l0,0c-3.321,1.681-0.556,13.809-0.556,13.809l1.857,7.753c-1.277-0.095-2.701,0.104-3.944,1.011 c-3.208,2.338-2.563,7.737,1.672,8.124c1.331,0.122,2.454-0.275,3.374-0.891C392.772,83.093,393.694,80.267,393.045,77.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M665.399,203.334l-0.096,0.342c0,0-2.136,10.08-4.981,17.441c-0.766,1.981-2.007,4.592-2.007,4.592 l0,0c3.727,0.183,7.334-11.754,7.334-11.754l2.227-7.675c1.066,0.716,2.404,1.249,3.938,1.076c3.954-0.446,6.07-5.47,2.573-7.907 c-1.1-0.766-2.274-0.978-3.381-0.898C668.328,198.744,666.123,200.749,665.399,203.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M160.098,402.81l-0.019,0.354c0,0,0.094,10.303-1.092,18.106c-0.319,2.1-0.967,4.917-0.967,4.917 l0,0c3.679-0.627,4.618-13.062,4.618-13.062l0.515-7.975c1.195,0.469,2.618,0.699,4.077,0.199c3.764-1.29,4.744-6.653,0.802-8.277 c-1.239-0.511-2.432-0.463-3.496-0.145C161.964,397.695,160.245,400.129,160.098,402.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M410.82,33.836l-0.095,0.341c0,0-2.131,10.055-4.969,17.398c-0.764,1.976-2.002,4.58-2.002,4.58 l0,0c3.718,0.183,7.316-11.725,7.316-11.725l2.222-7.656c1.063,0.714,2.398,1.246,3.928,1.073 c3.944-0.445,6.055-5.456,2.566-7.888c-1.097-0.764-2.269-0.975-3.373-0.895C413.741,29.258,411.541,31.258,410.82,33.836z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M548.103,228.277l16.142-3.929l3.534,17.035c0.425,2.047-0.413,4.196-2.195,5.289 c-1.429,0.877-3.525,1.458-6.504,0.856c-7.089-1.432-0.537-7.08,6.205-5.955l-3.496-12.591l-9.822,2.321 c0,0,2.18,11.133,1.923,13.037c-0.391,2.904-11.488,3.813-11.119-0.512c0.299-3.504,8.471-3.655,8.471-3.655L548.103,228.277z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M98.144,436.996l16.142-3.929l3.534,17.035c0.425,2.047-0.413,4.196-2.195,5.289 c-1.429,0.877-3.525,1.458-6.504,0.856c-7.089-1.432-0.537-7.08,6.205-5.955l-3.496-12.591l-9.822,2.321 c0,0,2.18,11.133,1.923,13.037c-0.391,2.904-11.488,3.814-11.119-0.512c0.299-3.504,8.471-3.655,8.471-3.655L98.144,436.996z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M455.768,439.523c-3.852-0.807-6.023-4.767-6.113-4.935c-0.45-0.837-0.125-1.866,0.725-2.306 c0.849-0.44,1.909-0.119,2.366,0.715c0.414,0.754,1.893,2.795,3.748,3.176c1.113,0.229,2.279-0.144,3.561-1.139 c1.698-1.318,0.817-5.054-1.345-9.917c-3.869,1.682-8.346,1.906-12.82,0.453c-8.508-2.763-16.566-11.677-15.388-25.364 c0.64-7.428,2.798-12.897,4.822-17.69c-2.897-6.178-5.058-12.122-5.723-17.361c-0.609-4.791,0.456-8.514,2.922-10.213 c1.581-1.089,3.529-1.201,5.345-0.308c3.163,1.557,5.152,5.648,5.322,10.943c0.213,6.674-1.829,11.659-4.043,16.879 c1.643,3.395,3.503,6.869,5.447,10.331c5.221-2.217,11.465-1.022,16.823,3.47c6.17,5.173,9.967,14.338,5.288,21.846 c-1.349,2.164-3.032,3.942-4.949,5.298c2.99,6.714,3.796,11.753,0.483,14.324c-1.158,0.899-2.332,1.488-3.513,1.763 C457.742,439.717,456.754,439.729,455.768,439.523z M452.402,413.11c-1.442,0.555-3.022,0.78-4.688,0.648 c-4.723-0.376-9.159-3.673-10.548-7.84c-1.28-3.841,0.138-7.835,3.891-10.96c0.175-0.146,0.353-0.287,0.532-0.423 c-1.464-2.607-2.886-5.227-4.209-7.824c-1.551,3.933-2.912,8.249-3.39,13.801c-1.018,11.818,5.788,19.467,12.985,21.804 c3.077,0.999,6.82,1.171,10.27-0.292C455.853,419.232,454.174,416.197,452.402,413.11z M446.302,395.795 c1.62,2.821,3.27,5.617,4.875,8.339c0.824,1.397,1.634,2.769,2.42,4.112c0.617-0.631,1.163-1.397,1.625-2.292 c0.436-0.843,1.488-1.176,2.351-0.745c0.863,0.431,1.209,1.464,0.774,2.307c-0.795,1.538-1.796,2.816-2.96,3.81 c1.826,3.169,3.485,6.156,4.866,8.914c1.264-0.999,2.438-2.294,3.46-3.935c3.661-5.873,0.474-13.223-4.565-17.448 c-3.083-2.585-7.347-4.448-11.494-3.481C447.202,395.48,446.751,395.619,446.302,395.795z M448.15,405.837 c-1.59-2.694-3.221-5.459-4.827-8.254c-2.692,2.245-3.67,4.765-2.83,7.288c0.951,2.855,4.17,5.207,7.486,5.471 c0.939,0.075,1.832-0.018,2.661-0.269C449.81,408.651,448.974,407.233,448.15,405.837z M434.548,357.749 c-1.05,0.724-1.989,2.943-1.473,7c0.512,4.029,2.009,8.579,4.082,13.376c1.556-3.916,2.686-7.707,2.534-12.46 c-0.151-4.729-1.917-7.249-3.382-7.97c-0.435-0.214-0.845-0.277-1.222-0.189C434.899,357.55,434.72,357.631,434.548,357.749z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3832E"
    },
    d: "M163.535,188.838c-2.842-2.484-2.797-6.816-2.794-6.999c0.016-0.912,0.772-1.62,1.69-1.588 c0.917,0.031,1.652,0.798,1.643,1.71c-0.008,0.825,0.27,3.227,1.642,4.417c0.824,0.714,1.973,0.95,3.513,0.721 c2.039-0.305,3.057-3.843,3.535-8.926c-4.026-0.411-7.875-2.327-10.934-5.645c-5.817-6.309-8.367-17.549-0.952-28.441 c4.025-5.911,8.4-9.471,12.345-12.528c0.48-6.528,1.466-12.514,3.371-17.207c1.742-4.293,4.381-6.906,7.242-7.168 c1.833-0.168,3.516,0.654,4.614,2.254c1.914,2.788,1.655,7.144-0.691,11.652c-2.957,5.681-7.007,8.891-11.312,12.216 c-0.221,3.611-0.298,7.39-0.299,11.199c5.408,0.599,10.068,4.533,12.439,10.806c2.729,7.225,1.599,16.674-5.842,20.754 c-2.145,1.176-4.388,1.872-6.628,2.106c-0.654,7.019-2.347,11.612-6.327,12.206c-1.391,0.208-2.649,0.148-3.766-0.176 C165.094,189.928,164.263,189.474,163.535,188.838z M173.13,165.169c-1.466-0.214-2.894-0.767-4.225-1.661 c-3.773-2.533-5.934-7.375-5.137-11.512c0.734-3.813,3.797-6.488,8.404-7.338c0.215-0.04,0.43-0.074,0.644-0.104 c0.001-2.868,0.043-5.727,0.156-8.521c-3.145,2.56-6.311,5.53-9.32,9.949c-6.404,9.405-4.306,19,0.615,24.336 c2.104,2.281,5.153,4.184,8.726,4.581C173.139,171.909,173.162,168.582,173.13,165.169z M176.164,147.822 c0.03,3.121,0.095,6.234,0.159,9.264c0.033,1.556,0.065,3.083,0.092,4.576c0.813-0.238,1.629-0.622,2.436-1.153 c0.76-0.5,1.797-0.285,2.316,0.481c0.519,0.766,0.323,1.792-0.436,2.292c-1.387,0.912-2.825,1.511-4.266,1.795 c0.038,3.508,0.022,6.786-0.119,9.741c1.527-0.242,3.117-0.773,4.742-1.665c5.821-3.191,6.609-10.836,4.38-16.737 c-1.364-3.611-4.055-7.172-7.977-8.312C177.065,147.981,176.622,147.886,176.164,147.822z M172.991,157.087 c-0.064-2.999-0.129-6.079-0.159-9.17c-3.306,0.613-5.308,2.26-5.79,4.765c-0.546,2.834,1.041,6.314,3.69,8.092 c0.75,0.504,1.54,0.846,2.352,1.025C173.057,160.221,173.024,158.643,172.991,157.087z M184.21,110.482 c-1.218,0.112-3.046,1.527-4.521,5.162c-1.465,3.61-2.351,8.119-2.87,13.104c3.141-2.544,5.867-5.184,7.973-9.229 c2.095-4.026,1.803-6.962,0.917-8.254c-0.264-0.384-0.576-0.629-0.933-0.733C184.598,110.48,184.409,110.464,184.21,110.482z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M712.109,146.043c-3.611-1.565-4.941-5.88-4.996-6.063c-0.273-0.91,0.253-1.853,1.174-2.113 c0.92-0.26,1.894,0.268,2.174,1.176c0.253,0.822,1.292,3.119,3.033,3.865c1.045,0.448,2.261,0.318,3.717-0.399 c1.928-0.95,1.816-4.786,0.677-9.985c-4.128,0.87-8.559,0.189-12.649-2.135c-7.779-4.418-13.879-14.77-9.973-27.94 c2.121-7.148,5.334-12.071,8.281-16.359c-1.596-6.635-2.517-12.891-2.115-18.157c0.367-4.816,2.159-8.248,4.916-9.417 c1.767-0.749,3.698-0.467,5.297,0.773c2.785,2.161,3.911,6.569,3.013,11.79c-1.133,6.58-4.136,11.053-7.355,15.721 c0.927,3.656,2.05,7.433,3.258,11.215c5.56-1.122,11.437,1.305,15.782,6.782c5.004,6.308,6.88,16.049,0.786,22.463 c-1.756,1.848-3.763,3.252-5.913,4.195c1.578,7.178,1.355,12.276-2.408,14.129c-1.315,0.648-2.584,0.988-3.796,1.021 C714.003,146.63,713.033,146.443,712.109,146.043z M714.124,119.493c-1.524,0.253-3.117,0.157-4.723-0.309 c-4.551-1.318-8.234-5.44-8.756-9.801c-0.481-4.02,1.711-7.648,6.016-9.954c0.201-0.108,0.404-0.21,0.607-0.308 c-0.91-2.848-1.776-5.701-2.55-8.511c-2.311,3.54-4.511,7.495-6.096,12.838c-3.374,11.372,1.755,20.233,8.335,23.97 c2.813,1.598,6.445,2.519,10.119,1.779C716.272,126.184,715.238,122.873,714.124,119.493z M711.63,101.305 c1.02,3.09,2.073,6.16,3.099,9.149c0.526,1.534,1.043,3.041,1.544,4.515c0.732-0.494,1.421-1.135,2.053-1.919 c0.596-0.738,1.694-0.853,2.453-0.257c0.759,0.596,0.89,1.677,0.294,2.415c-1.088,1.346-2.326,2.398-3.666,3.137 c1.152,3.471,2.175,6.731,2.974,9.711c1.44-0.725,2.85-1.757,4.181-3.159c4.767-5.017,3.124-12.858-0.963-18.01 c-2.501-3.152-6.303-5.835-10.559-5.722C712.575,101.177,712.105,101.223,711.63,101.305z M711.42,111.513 c-1.016-2.958-2.057-5.995-3.068-9.056c-3.089,1.658-4.553,3.93-4.238,6.57c0.358,2.988,3.038,5.939,6.233,6.864 c0.905,0.262,1.798,0.351,2.661,0.271C712.481,114.604,711.947,113.047,711.42,111.513z M707.767,61.672 c-1.174,0.498-2.54,2.483-2.851,6.561c-0.309,4.05,0.243,8.808,1.309,13.924c2.312-3.523,4.181-7.01,4.988-11.695 c0.803-4.663-0.42-7.486-1.71-8.487c-0.383-0.297-0.771-0.442-1.159-0.431C708.152,61.548,707.959,61.591,707.767,61.672z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M40.355,464.306c-3.007-1.603-3.854-5.421-3.889-5.583c-0.172-0.805,0.347-1.582,1.161-1.742 c0.813-0.16,1.616,0.363,1.795,1.167c0.161,0.727,0.898,2.782,2.348,3.548c0.87,0.46,1.93,0.432,3.237-0.085 c1.731-0.685,1.902-4.005,1.282-8.572c-3.624,0.462-7.401-0.435-10.769-2.726c-6.406-4.357-10.949-13.719-6.657-24.814 c2.33-6.022,5.448-10.047,8.291-13.542c-0.914-5.839-1.272-11.303-0.557-15.82c0.653-4.131,2.439-6.969,4.901-7.785 c1.578-0.523,3.225-0.145,4.519,1.037c2.253,2.06,2.917,5.943,1.777,10.387c-1.438,5.601-4.342,9.252-7.447,13.056 c0.544,3.221,1.25,6.559,2.029,9.908c4.878-0.58,9.781,1.925,13.149,6.956c3.878,5.794,4.818,14.334-0.89,19.445 c-1.645,1.473-3.475,2.544-5.397,3.208c0.861,6.306,0.312,10.691-3.066,12.027c-1.181,0.467-2.299,0.673-3.348,0.616 C41.95,464.945,41.126,464.716,40.355,464.306z M43.949,441.53c-1.333,0.112-2.701-0.083-4.055-0.596 c-3.836-1.455-6.727-5.271-6.873-9.072c-0.135-3.503,2.011-6.482,5.888-8.172c0.181-0.079,0.363-0.153,0.545-0.223 c-0.586-2.522-1.135-5.045-1.607-7.525c-2.242,2.895-4.417,6.154-6.159,10.656c-3.707,9.581,0.102,17.588,5.52,21.273 c2.317,1.576,5.387,2.624,8.61,2.243C45.337,447.455,44.675,444.525,43.949,441.53z M43.067,425.655 c0.664,2.738,1.359,5.462,2.036,8.113c0.347,1.361,0.688,2.698,1.017,4.005c0.666-0.375,1.305-0.88,1.906-1.513 c0.566-0.595,1.522-0.618,2.135-0.051c0.613,0.567,0.651,1.51,0.085,2.105c-1.033,1.086-2.175,1.907-3.383,2.451 c0.752,3.077,1.408,5.962,1.889,8.59c1.293-0.525,2.583-1.318,3.829-2.435c4.465-3.997,3.594-10.88,0.427-15.613 c-1.938-2.896-5.033-5.477-8.715-5.676C43.892,425.611,43.483,425.618,43.067,425.655z M42.173,434.452 c-0.67-2.625-1.357-5.319-2.016-8.031c-2.782,1.215-4.205,3.074-4.117,5.375c0.1,2.604,2.207,5.339,4.9,6.36 c0.763,0.289,1.528,0.429,2.278,0.42C42.873,437.194,42.52,435.813,42.173,434.452z M42.501,391.176 c-1.048,0.348-2.366,1.966-2.919,5.464c-0.549,3.474-0.406,7.62,0.157,12.11c2.242-2.88,4.099-5.759,5.123-9.747 c1.019-3.968,0.161-6.491-0.883-7.445c-0.31-0.284-0.635-0.435-0.97-0.453C42.842,391.095,42.673,391.119,42.501,391.176z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE2D00"
    },
    d: "M40.914,338.784c0,2.139-1.734,3.873-3.873,3.873c-2.139,0-3.873-1.734-3.873-3.873 c0-2.139,1.734-3.872,3.873-3.872C39.18,334.911,40.914,336.645,40.914,338.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE2D00"
    },
    d: "M221.166,368.822c0,2.139-1.734,3.873-3.873,3.873c-2.139,0-3.873-1.734-3.873-3.873 c0-2.139,1.734-3.873,3.873-3.873C219.432,364.95,221.166,366.684,221.166,368.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE2D00"
    },
    d: "M428.529,82.692c0,1.365-1.107,2.472-2.472,2.472c-1.365,0-2.472-1.107-2.472-2.472 c0-1.365,1.107-2.472,2.472-2.472C427.422,80.221,428.529,81.327,428.529,82.692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE2D00"
    },
    d: "M408.763,399.769c0,1.365-1.107,2.472-2.472,2.472c-1.365,0-2.472-1.107-2.472-2.472 c0-1.365,1.107-2.472,2.472-2.472C407.656,397.297,408.763,398.404,408.763,399.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D52A2C"
    },
    d: "M598.209,57.572c0,2.956-2.397,5.353-5.353,5.353c-2.956,0-5.353-2.397-5.353-5.353 c0-2.956,2.397-5.353,5.353-5.353C595.812,52.219,598.209,54.616,598.209,57.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE2D00"
    },
    d: "M717.544,180.006c0,3.41-2.764,6.174-6.174,6.174c-3.409,0-6.174-2.764-6.174-6.174 c0-3.41,2.764-6.174,6.174-6.174C714.78,173.832,717.544,176.596,717.544,180.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE2D00"
    },
    d: "M71.956,327.402c0,3.472-2.814,6.286-6.286,6.286c-3.472,0-6.286-2.814-6.286-6.286 c0-3.472,2.815-6.286,6.286-6.286C69.142,321.115,71.956,323.93,71.956,327.402z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M433.958,469.014c0-5.197-5.784-10.981-10.982-10.981c5.197,0,10.982-5.784,10.982-10.981 c0,5.197,5.784,10.981,10.981,10.981C439.742,458.032,433.958,463.816,433.958,469.014z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M726.996,353.842c0-2.599-2.892-5.491-5.491-5.491c2.599,0,5.491-2.892,5.491-5.491 c0,2.599,2.892,5.491,5.491,5.491C729.888,348.352,726.996,351.244,726.996,353.842z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M479.055,480.285c0-2.865-3.188-6.053-6.053-6.053c2.865,0,6.053-3.188,6.053-6.052 c0,2.865,3.188,6.052,6.052,6.052C482.243,474.232,479.055,477.42,479.055,480.285z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M499.342,450.92c0-1.432-1.594-3.026-3.026-3.026c1.432,0,3.026-1.594,3.026-3.026 c0,1.432,1.594,3.026,3.026,3.026C500.936,447.893,499.342,449.487,499.342,450.92z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M647.721,178.224c0-2.865-3.188-6.053-6.052-6.053c2.865,0,6.052-3.188,6.052-6.052 c0,2.865,3.188,6.052,6.053,6.052C650.909,172.171,647.721,175.359,647.721,178.224z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M621.694,97.457c0-2.865-3.188-6.053-6.052-6.053c2.864,0,6.052-3.188,6.052-6.053 c0,2.865,3.188,6.053,6.053,6.053C624.883,91.405,621.694,94.593,621.694,97.457z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M494.298,57.572c0-2.865-3.188-6.053-6.053-6.053c2.865,0,6.053-3.188,6.053-6.052 c0,2.865,3.188,6.052,6.052,6.052C497.486,51.52,494.298,54.708,494.298,57.572z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M457.246,32.044c0-2.865-3.188-6.052-6.052-6.052c2.865,0,6.052-3.188,6.052-6.052 c0,2.865,3.188,6.052,6.053,6.052C460.434,25.991,457.246,29.179,457.246,32.044z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M184.3,374.875c0-2.865-3.188-6.053-6.053-6.053c2.865,0,6.053-3.188,6.053-6.052 c0,2.865,3.188,6.052,6.052,6.052C187.488,368.822,184.3,372.01,184.3,374.875z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M132.862,369.597c0-2.865-3.188-6.053-6.053-6.053c2.865,0,6.053-3.188,6.053-6.052 c0,2.865,3.188,6.052,6.053,6.052C136.05,363.545,132.862,366.733,132.862,369.597z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M673.029,168.676c0-4.722-5.256-9.978-9.978-9.978c4.722,0,9.978-5.255,9.978-9.978 c0,4.722,5.255,9.978,9.978,9.978C678.284,158.698,673.029,163.953,673.029,168.676z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M583.76,474.233c0-3.234-3.599-6.833-6.833-6.833c3.234,0,6.833-3.599,6.833-6.833 c0,3.234,3.599,6.833,6.833,6.833C587.359,467.4,583.76,470.999,583.76,474.233z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M530.382,47.24c0-5.824-6.482-12.306-12.306-12.306c5.824,0,12.306-6.482,12.306-12.306 c0,5.824,6.482,12.306,12.306,12.306C536.864,34.934,530.382,41.416,530.382,47.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M170.01,359.33c0-5.824-6.482-12.306-12.306-12.306c5.824,0,12.306-6.482,12.306-12.306 c0,5.824,6.482,12.306,12.306,12.306C176.492,347.024,170.01,353.506,170.01,359.33z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.32a7b9838120a35e13fdff5c15b45858.svg";
export { ForwardRef as ReactComponent };